// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IMilitaryZipCode {
    id: number;
    militaryCityPrefixTypeId: number;
    jurisdictionId: number;
    value: string;
    city: string;
    active: boolean;
}

export class MilitaryZipCode implements IMilitaryZipCode, IBaseType {
    public id: number;
    public militaryCityPrefixTypeId: number;
    public jurisdictionId: number;
    public value: string;
    public city: string;
    public active: boolean;

    /**
		Returns 09001 MilitaryZipCode
	**/
    get NineThousandAndOne(): IMilitaryZipCode {
        return this.FromId(1);
    }
    /**
		Returns 09002 MilitaryZipCode
	**/
    get NineThousandAndTwo(): IMilitaryZipCode {
        return this.FromId(2);
    }
    /**
		Returns 09008 MilitaryZipCode
	**/
    get NineThousandAndEight(): IMilitaryZipCode {
        return this.FromId(3);
    }
    /**
		Returns 09009 MilitaryZipCode
	**/
    get NineThousandAndNine(): IMilitaryZipCode {
        return this.FromId(4);
    }
    /**
		Returns 09011 MilitaryZipCode
	**/
    get NineThousandAndEleven(): IMilitaryZipCode {
        return this.FromId(5);
    }
    /**
		Returns 09012 MilitaryZipCode
	**/
    get NineThousandAndTwelve(): IMilitaryZipCode {
        return this.FromId(6);
    }
    /**
		Returns 09014 MilitaryZipCode
	**/
    get NineThousandAndFourteen(): IMilitaryZipCode {
        return this.FromId(7);
    }
    /**
		Returns 09017 MilitaryZipCode
	**/
    get NineThousandAndSeventeen(): IMilitaryZipCode {
        return this.FromId(8);
    }
    /**
		Returns 09020 MilitaryZipCode
	**/
    get NineThousandAndTwenty(): IMilitaryZipCode {
        return this.FromId(9);
    }
    /**
		Returns 09021 MilitaryZipCode
	**/
    get NineThousandAndTwentyOne(): IMilitaryZipCode {
        return this.FromId(10);
    }
    /**
		Returns 09023 MilitaryZipCode
	**/
    get NineThousandAndTwentyThree(): IMilitaryZipCode {
        return this.FromId(11);
    }
    /**
		Returns 09026 MilitaryZipCode
	**/
    get NineThousandAndTwentySix(): IMilitaryZipCode {
        return this.FromId(12);
    }
    /**
		Returns 09028 MilitaryZipCode
	**/
    get NineThousandAndTwentyEight(): IMilitaryZipCode {
        return this.FromId(13);
    }
    /**
		Returns 09031 MilitaryZipCode
	**/
    get NineThousandAndThirtyOne(): IMilitaryZipCode {
        return this.FromId(14);
    }
    /**
		Returns 09033 MilitaryZipCode
	**/
    get NineThousandAndThirtyThree(): IMilitaryZipCode {
        return this.FromId(15);
    }
    /**
		Returns 09034 MilitaryZipCode
	**/
    get NineThousandAndThirtyFour(): IMilitaryZipCode {
        return this.FromId(16);
    }
    /**
		Returns 09035 MilitaryZipCode
	**/
    get NineThousandAndThirtyFive(): IMilitaryZipCode {
        return this.FromId(17);
    }
    /**
		Returns 09036 MilitaryZipCode
	**/
    get NineThousandAndThirtySix(): IMilitaryZipCode {
        return this.FromId(18);
    }
    /**
		Returns 09038 MilitaryZipCode
	**/
    get NineThousandAndThirtyEight(): IMilitaryZipCode {
        return this.FromId(19);
    }
    /**
		Returns 09039 MilitaryZipCode
	**/
    get NineThousandAndThirtyNine(): IMilitaryZipCode {
        return this.FromId(20);
    }
    /**
		Returns 09042 MilitaryZipCode
	**/
    get NineThousandAndFortyTwo(): IMilitaryZipCode {
        return this.FromId(21);
    }
    /**
		Returns 09045 MilitaryZipCode
	**/
    get NineThousandAndFortyFive(): IMilitaryZipCode {
        return this.FromId(22);
    }
    /**
		Returns 09046 MilitaryZipCode
	**/
    get NineThousandAndFortySix(): IMilitaryZipCode {
        return this.FromId(23);
    }
    /**
		Returns 09047 MilitaryZipCode
	**/
    get NineThousandAndFortySeven(): IMilitaryZipCode {
        return this.FromId(24);
    }
    /**
		Returns 09049 MilitaryZipCode
	**/
    get NineThousandAndFortyNine(): IMilitaryZipCode {
        return this.FromId(25);
    }
    /**
		Returns 09050 MilitaryZipCode
	**/
    get NineThousandAndFifty(): IMilitaryZipCode {
        return this.FromId(26);
    }
    /**
		Returns 09052 MilitaryZipCode
	**/
    get NineThousandAndFiftyTwo(): IMilitaryZipCode {
        return this.FromId(27);
    }
    /**
		Returns 09053 MilitaryZipCode
	**/
    get NineThousandAndFiftyThree(): IMilitaryZipCode {
        return this.FromId(28);
    }
    /**
		Returns 09054 MilitaryZipCode
	**/
    get NineThousandAndFiftyFour(): IMilitaryZipCode {
        return this.FromId(29);
    }
    /**
		Returns 09055 MilitaryZipCode
	**/
    get NineThousandAndFiftyFive(): IMilitaryZipCode {
        return this.FromId(30);
    }
    /**
		Returns 09056 MilitaryZipCode
	**/
    get NineThousandAndFiftySix(): IMilitaryZipCode {
        return this.FromId(31);
    }
    /**
		Returns 09057 MilitaryZipCode
	**/
    get NineThousandAndFiftySeven(): IMilitaryZipCode {
        return this.FromId(32);
    }
    /**
		Returns 09058 MilitaryZipCode
	**/
    get NineThousandAndFiftyEight(): IMilitaryZipCode {
        return this.FromId(33);
    }
    /**
		Returns 09059 MilitaryZipCode
	**/
    get NineThousandAndFiftyNine(): IMilitaryZipCode {
        return this.FromId(34);
    }
    /**
		Returns 09061 MilitaryZipCode
	**/
    get NineThousandAndSixtyOne(): IMilitaryZipCode {
        return this.FromId(35);
    }
    /**
		Returns 09063 MilitaryZipCode
	**/
    get NineThousandAndSixtyThree(): IMilitaryZipCode {
        return this.FromId(36);
    }
    /**
		Returns 09065 MilitaryZipCode
	**/
    get NineThousandAndSixtyFive(): IMilitaryZipCode {
        return this.FromId(37);
    }
    /**
		Returns 09066 MilitaryZipCode
	**/
    get NineThousandAndSixtySix(): IMilitaryZipCode {
        return this.FromId(38);
    }
    /**
		Returns 09067 MilitaryZipCode
	**/
    get NineThousandAndSixtySeven(): IMilitaryZipCode {
        return this.FromId(39);
    }
    /**
		Returns 09069 MilitaryZipCode
	**/
    get NineThousandAndSixtyNine(): IMilitaryZipCode {
        return this.FromId(40);
    }
    /**
		Returns 09070 MilitaryZipCode
	**/
    get NineThousandAndSeventy(): IMilitaryZipCode {
        return this.FromId(41);
    }
    /**
		Returns 09072 MilitaryZipCode
	**/
    get NineThousandAndSeventyTwo(): IMilitaryZipCode {
        return this.FromId(42);
    }
    /**
		Returns 09074 MilitaryZipCode
	**/
    get NineThousandAndSeventyFour(): IMilitaryZipCode {
        return this.FromId(43);
    }
    /**
		Returns 09075 MilitaryZipCode
	**/
    get NineThousandAndSeventyFive(): IMilitaryZipCode {
        return this.FromId(44);
    }
    /**
		Returns 09076 MilitaryZipCode
	**/
    get NineThousandAndSeventySix(): IMilitaryZipCode {
        return this.FromId(45);
    }
    /**
		Returns 09077 MilitaryZipCode
	**/
    get NineThousandAndSeventySeven(): IMilitaryZipCode {
        return this.FromId(46);
    }
    /**
		Returns 09079 MilitaryZipCode
	**/
    get NineThousandAndSeventyNine(): IMilitaryZipCode {
        return this.FromId(47);
    }
    /**
		Returns 09080 MilitaryZipCode
	**/
    get NineThousandAndEighty(): IMilitaryZipCode {
        return this.FromId(48);
    }
    /**
		Returns 09081 MilitaryZipCode
	**/
    get NineThousandAndEightyOne(): IMilitaryZipCode {
        return this.FromId(49);
    }
    /**
		Returns 09083 MilitaryZipCode
	**/
    get NineThousandAndEightyThree(): IMilitaryZipCode {
        return this.FromId(50);
    }
    /**
		Returns 09084 MilitaryZipCode
	**/
    get NineThousandAndEightyFour(): IMilitaryZipCode {
        return this.FromId(51);
    }
    /**
		Returns 09086 MilitaryZipCode
	**/
    get NineThousandAndEightySix(): IMilitaryZipCode {
        return this.FromId(52);
    }
    /**
		Returns 09088 MilitaryZipCode
	**/
    get NineThousandAndEightyEight(): IMilitaryZipCode {
        return this.FromId(53);
    }
    /**
		Returns 09090 MilitaryZipCode
	**/
    get NineThousandAndNinety(): IMilitaryZipCode {
        return this.FromId(54);
    }
    /**
		Returns 09091 MilitaryZipCode
	**/
    get NineThousandAndNinetyOne(): IMilitaryZipCode {
        return this.FromId(55);
    }
    /**
		Returns 09092 MilitaryZipCode
	**/
    get NineThousandAndNinetyTwo(): IMilitaryZipCode {
        return this.FromId(56);
    }
    /**
		Returns 09093 MilitaryZipCode
	**/
    get NineThousandAndNinetyThree(): IMilitaryZipCode {
        return this.FromId(57);
    }
    /**
		Returns 09094 MilitaryZipCode
	**/
    get NineThousandAndNinetyFour(): IMilitaryZipCode {
        return this.FromId(58);
    }
    /**
		Returns 09096 MilitaryZipCode
	**/
    get NineThousandAndNinetySix(): IMilitaryZipCode {
        return this.FromId(59);
    }
    /**
		Returns 09097 MilitaryZipCode
	**/
    get NineThousandAndNinetySeven(): IMilitaryZipCode {
        return this.FromId(60);
    }
    /**
		Returns 09098 MilitaryZipCode
	**/
    get NineThousandAndNinetyEight(): IMilitaryZipCode {
        return this.FromId(61);
    }
    /**
		Returns 09099 MilitaryZipCode
	**/
    get NineThousandAndNinetyNine(): IMilitaryZipCode {
        return this.FromId(62);
    }
    /**
		Returns 09102 MilitaryZipCode
	**/
    get NineThousandOneHundredAndTwo(): IMilitaryZipCode {
        return this.FromId(63);
    }
    /**
		Returns 09103 MilitaryZipCode
	**/
    get NineThousandOneHundredAndThree(): IMilitaryZipCode {
        return this.FromId(64);
    }
    /**
		Returns 09104 MilitaryZipCode
	**/
    get NineThousandOneHundredAndFour(): IMilitaryZipCode {
        return this.FromId(65);
    }
    /**
		Returns 09105 MilitaryZipCode
	**/
    get NineThousandOneHundredAndFive(): IMilitaryZipCode {
        return this.FromId(66);
    }
    /**
		Returns 09107 MilitaryZipCode
	**/
    get NineThousandOneHundredAndSeven(): IMilitaryZipCode {
        return this.FromId(67);
    }
    /**
		Returns 09108 MilitaryZipCode
	**/
    get NineThousandOneHundredAndEight(): IMilitaryZipCode {
        return this.FromId(68);
    }
    /**
		Returns 09109 MilitaryZipCode
	**/
    get NineThousandOneHundredAndNine(): IMilitaryZipCode {
        return this.FromId(69);
    }
    /**
		Returns 09110 MilitaryZipCode
	**/
    get NineThousandOneHundredAndTen(): IMilitaryZipCode {
        return this.FromId(70);
    }
    /**
		Returns 09111 MilitaryZipCode
	**/
    get NineThousandOneHundredAndEleven(): IMilitaryZipCode {
        return this.FromId(71);
    }
    /**
		Returns 09112 MilitaryZipCode
	**/
    get NineThousandOneHundredAndTwelve(): IMilitaryZipCode {
        return this.FromId(72);
    }
    /**
		Returns 09114 MilitaryZipCode
	**/
    get NineThousandOneHundredAndFourteen(): IMilitaryZipCode {
        return this.FromId(73);
    }
    /**
		Returns 09121 MilitaryZipCode
	**/
    get NineThousandOneHundredAndTwentyOne(): IMilitaryZipCode {
        return this.FromId(74);
    }
    /**
		Returns 09123 MilitaryZipCode
	**/
    get NineThousandOneHundredAndTwentyThree(): IMilitaryZipCode {
        return this.FromId(75);
    }
    /**
		Returns 09125 MilitaryZipCode
	**/
    get NineThousandOneHundredAndTwentyFive(): IMilitaryZipCode {
        return this.FromId(76);
    }
    /**
		Returns 09127 MilitaryZipCode
	**/
    get NineThousandOneHundredAndTwentySeven(): IMilitaryZipCode {
        return this.FromId(77);
    }
    /**
		Returns 09128 MilitaryZipCode
	**/
    get NineThousandOneHundredAndTwentyEight(): IMilitaryZipCode {
        return this.FromId(78);
    }
    /**
		Returns 09130 MilitaryZipCode
	**/
    get NineThousandOneHundredAndThirty(): IMilitaryZipCode {
        return this.FromId(79);
    }
    /**
		Returns 09131 MilitaryZipCode
	**/
    get NineThousandOneHundredAndThirtyOne(): IMilitaryZipCode {
        return this.FromId(80);
    }
    /**
		Returns 09132 MilitaryZipCode
	**/
    get NineThousandOneHundredAndThirtyTwo(): IMilitaryZipCode {
        return this.FromId(81);
    }
    /**
		Returns 09133 MilitaryZipCode
	**/
    get NineThousandOneHundredAndThirtyThree(): IMilitaryZipCode {
        return this.FromId(82);
    }
    /**
		Returns 09137 MilitaryZipCode
	**/
    get NineThousandOneHundredAndThirtySeven(): IMilitaryZipCode {
        return this.FromId(83);
    }
    /**
		Returns 09139 MilitaryZipCode
	**/
    get NineThousandOneHundredAndThirtyNine(): IMilitaryZipCode {
        return this.FromId(84);
    }
    /**
		Returns 09140 MilitaryZipCode
	**/
    get NineThousandOneHundredAndForty(): IMilitaryZipCode {
        return this.FromId(85);
    }
    /**
		Returns 09141 MilitaryZipCode
	**/
    get NineThousandOneHundredAndFortyOne(): IMilitaryZipCode {
        return this.FromId(86);
    }
    /**
		Returns 09142 MilitaryZipCode
	**/
    get NineThousandOneHundredAndFortyTwo(): IMilitaryZipCode {
        return this.FromId(87);
    }
    /**
		Returns 09144 MilitaryZipCode
	**/
    get NineThousandOneHundredAndFortyFour(): IMilitaryZipCode {
        return this.FromId(88);
    }
    /**
		Returns 09146 MilitaryZipCode
	**/
    get NineThousandOneHundredAndFortySix(): IMilitaryZipCode {
        return this.FromId(89);
    }
    /**
		Returns 09150 MilitaryZipCode
	**/
    get NineThousandOneHundredAndFifty(): IMilitaryZipCode {
        return this.FromId(90);
    }
    /**
		Returns 09154 MilitaryZipCode
	**/
    get NineThousandOneHundredAndFiftyFour(): IMilitaryZipCode {
        return this.FromId(91);
    }
    /**
		Returns 09157 MilitaryZipCode
	**/
    get NineThousandOneHundredAndFiftySeven(): IMilitaryZipCode {
        return this.FromId(92);
    }
    /**
		Returns 09159 MilitaryZipCode
	**/
    get NineThousandOneHundredAndFiftyNine(): IMilitaryZipCode {
        return this.FromId(93);
    }
    /**
		Returns 09160 MilitaryZipCode
	**/
    get NineThousandOneHundredAndSixty(): IMilitaryZipCode {
        return this.FromId(94);
    }
    /**
		Returns 09162 MilitaryZipCode
	**/
    get NineThousandOneHundredAndSixtyTwo(): IMilitaryZipCode {
        return this.FromId(95);
    }
    /**
		Returns 09164 MilitaryZipCode
	**/
    get NineThousandOneHundredAndSixtyFour(): IMilitaryZipCode {
        return this.FromId(96);
    }
    /**
		Returns 09165 MilitaryZipCode
	**/
    get NineThousandOneHundredAndSixtyFive(): IMilitaryZipCode {
        return this.FromId(97);
    }
    /**
		Returns 09166 MilitaryZipCode
	**/
    get NineThousandOneHundredAndSixtySix(): IMilitaryZipCode {
        return this.FromId(98);
    }
    /**
		Returns 09169 MilitaryZipCode
	**/
    get NineThousandOneHundredAndSixtyNine(): IMilitaryZipCode {
        return this.FromId(99);
    }
    /**
		Returns 09172 MilitaryZipCode
	**/
    get NineThousandOneHundredAndSeventyTwo(): IMilitaryZipCode {
        return this.FromId(100);
    }
    /**
		Returns 09173 MilitaryZipCode
	**/
    get NineThousandOneHundredAndSeventyThree(): IMilitaryZipCode {
        return this.FromId(101);
    }
    /**
		Returns 09175 MilitaryZipCode
	**/
    get NineThousandOneHundredAndSeventyFive(): IMilitaryZipCode {
        return this.FromId(102);
    }
    /**
		Returns 09176 MilitaryZipCode
	**/
    get NineThousandOneHundredAndSeventySix(): IMilitaryZipCode {
        return this.FromId(103);
    }
    /**
		Returns 09177 MilitaryZipCode
	**/
    get NineThousandOneHundredAndSeventySeven(): IMilitaryZipCode {
        return this.FromId(104);
    }
    /**
		Returns 09178 MilitaryZipCode
	**/
    get NineThousandOneHundredAndSeventyEight(): IMilitaryZipCode {
        return this.FromId(105);
    }
    /**
		Returns 09179 MilitaryZipCode
	**/
    get NineThousandOneHundredAndSeventyNine(): IMilitaryZipCode {
        return this.FromId(106);
    }
    /**
		Returns 09180 MilitaryZipCode
	**/
    get NineThousandOneHundredAndEighty(): IMilitaryZipCode {
        return this.FromId(107);
    }
    /**
		Returns 09182 MilitaryZipCode
	**/
    get NineThousandOneHundredAndEightyTwo(): IMilitaryZipCode {
        return this.FromId(108);
    }
    /**
		Returns 09185 MilitaryZipCode
	**/
    get NineThousandOneHundredAndEightyFive(): IMilitaryZipCode {
        return this.FromId(109);
    }
    /**
		Returns 09188 MilitaryZipCode
	**/
    get NineThousandOneHundredAndEightyEight(): IMilitaryZipCode {
        return this.FromId(110);
    }
    /**
		Returns 09189 MilitaryZipCode
	**/
    get NineThousandOneHundredAndEightyNine(): IMilitaryZipCode {
        return this.FromId(111);
    }
    /**
		Returns 09192 MilitaryZipCode
	**/
    get NineThousandOneHundredAndNinetyTwo(): IMilitaryZipCode {
        return this.FromId(112);
    }
    /**
		Returns 09193 MilitaryZipCode
	**/
    get NineThousandOneHundredAndNinetyThree(): IMilitaryZipCode {
        return this.FromId(113);
    }
    /**
		Returns 09194 MilitaryZipCode
	**/
    get NineThousandOneHundredAndNinetyFour(): IMilitaryZipCode {
        return this.FromId(114);
    }
    /**
		Returns 09205 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndFive(): IMilitaryZipCode {
        return this.FromId(115);
    }
    /**
		Returns 09206 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndSix(): IMilitaryZipCode {
        return this.FromId(116);
    }
    /**
		Returns 09209 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndNine(): IMilitaryZipCode {
        return this.FromId(117);
    }
    /**
		Returns 09210 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndTen(): IMilitaryZipCode {
        return this.FromId(118);
    }
    /**
		Returns 09211 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndEleven(): IMilitaryZipCode {
        return this.FromId(119);
    }
    /**
		Returns 09213 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndThirteen(): IMilitaryZipCode {
        return this.FromId(120);
    }
    /**
		Returns 09214 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndFourteen(): IMilitaryZipCode {
        return this.FromId(121);
    }
    /**
		Returns 09220 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndTwenty(): IMilitaryZipCode {
        return this.FromId(122);
    }
    /**
		Returns 09221 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndTwentyOne(): IMilitaryZipCode {
        return this.FromId(123);
    }
    /**
		Returns 09222 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndTwentyTwo(): IMilitaryZipCode {
        return this.FromId(124);
    }
    /**
		Returns 09223 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndTwentyThree(): IMilitaryZipCode {
        return this.FromId(125);
    }
    /**
		Returns 09224 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndTwentyFour(): IMilitaryZipCode {
        return this.FromId(126);
    }
    /**
		Returns 09225 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndTwentyFive(): IMilitaryZipCode {
        return this.FromId(127);
    }
    /**
		Returns 09226 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndTwentySix(): IMilitaryZipCode {
        return this.FromId(128);
    }
    /**
		Returns 09227 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndTwentySeven(): IMilitaryZipCode {
        return this.FromId(129);
    }
    /**
		Returns 09235 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndThirtyFive(): IMilitaryZipCode {
        return this.FromId(130);
    }
    /**
		Returns 09237 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndThirtySeven(): IMilitaryZipCode {
        return this.FromId(131);
    }
    /**
		Returns 09238 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndThirtyEight(): IMilitaryZipCode {
        return this.FromId(132);
    }
    /**
		Returns 09240 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndForty(): IMilitaryZipCode {
        return this.FromId(133);
    }
    /**
		Returns 09242 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndFortyTwo(): IMilitaryZipCode {
        return this.FromId(134);
    }
    /**
		Returns 09244 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndFortyFour(): IMilitaryZipCode {
        return this.FromId(135);
    }
    /**
		Returns 09245 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndFortyFive(): IMilitaryZipCode {
        return this.FromId(136);
    }
    /**
		Returns 09250 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndFifty(): IMilitaryZipCode {
        return this.FromId(137);
    }
    /**
		Returns 09252 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndFiftyTwo(): IMilitaryZipCode {
        return this.FromId(138);
    }
    /**
		Returns 09253 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndFiftyThree(): IMilitaryZipCode {
        return this.FromId(139);
    }
    /**
		Returns 09254 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndFiftyFour(): IMilitaryZipCode {
        return this.FromId(140);
    }
    /**
		Returns 09255 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndFiftyFive(): IMilitaryZipCode {
        return this.FromId(141);
    }
    /**
		Returns 09262 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndSixtyTwo(): IMilitaryZipCode {
        return this.FromId(142);
    }
    /**
		Returns 09263 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndSixtyThree(): IMilitaryZipCode {
        return this.FromId(143);
    }
    /**
		Returns 09264 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndSixtyFour(): IMilitaryZipCode {
        return this.FromId(144);
    }
    /**
		Returns 09265 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndSixtyFive(): IMilitaryZipCode {
        return this.FromId(145);
    }
    /**
		Returns 09266 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndSixtySix(): IMilitaryZipCode {
        return this.FromId(146);
    }
    /**
		Returns 09267 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndSixtySeven(): IMilitaryZipCode {
        return this.FromId(147);
    }
    /**
		Returns 09279 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndSeventyNine(): IMilitaryZipCode {
        return this.FromId(148);
    }
    /**
		Returns 09281 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndEightyOne(): IMilitaryZipCode {
        return this.FromId(149);
    }
    /**
		Returns 09283 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndEightyThree(): IMilitaryZipCode {
        return this.FromId(150);
    }
    /**
		Returns 09285 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndEightyFive(): IMilitaryZipCode {
        return this.FromId(151);
    }
    /**
		Returns 09286 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndEightySix(): IMilitaryZipCode {
        return this.FromId(152);
    }
    /**
		Returns 09289 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndEightyNine(): IMilitaryZipCode {
        return this.FromId(153);
    }
    /**
		Returns 09291 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndNinetyOne(): IMilitaryZipCode {
        return this.FromId(154);
    }
    /**
		Returns 09292 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndNinetyTwo(): IMilitaryZipCode {
        return this.FromId(155);
    }
    /**
		Returns 09293 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndNinetyThree(): IMilitaryZipCode {
        return this.FromId(156);
    }
    /**
		Returns 09294 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndNinetyFour(): IMilitaryZipCode {
        return this.FromId(157);
    }
    /**
		Returns 09295 MilitaryZipCode
	**/
    get NineThousandTwoHundredAndNinetyFive(): IMilitaryZipCode {
        return this.FromId(158);
    }
    /**
		Returns 09305 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndFive(): IMilitaryZipCode {
        return this.FromId(159);
    }
    /**
		Returns 09306 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndSix(): IMilitaryZipCode {
        return this.FromId(160);
    }
    /**
		Returns 09308 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndEight(): IMilitaryZipCode {
        return this.FromId(161);
    }
    /**
		Returns 09309 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndNine(): IMilitaryZipCode {
        return this.FromId(162);
    }
    /**
		Returns 09311 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndEleven(): IMilitaryZipCode {
        return this.FromId(163);
    }
    /**
		Returns 09312 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndTwelve(): IMilitaryZipCode {
        return this.FromId(164);
    }
    /**
		Returns 09315 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndFifteen(): IMilitaryZipCode {
        return this.FromId(165);
    }
    /**
		Returns 09316 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndSixteen(): IMilitaryZipCode {
        return this.FromId(166);
    }
    /**
		Returns 09317 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndSeventeen(): IMilitaryZipCode {
        return this.FromId(167);
    }
    /**
		Returns 09320 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndTwenty(): IMilitaryZipCode {
        return this.FromId(168);
    }
    /**
		Returns 09321 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndTwentyOne(): IMilitaryZipCode {
        return this.FromId(169);
    }
    /**
		Returns 09322 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndTwentyTwo(): IMilitaryZipCode {
        return this.FromId(170);
    }
    /**
		Returns 09323 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndTwentyThree(): IMilitaryZipCode {
        return this.FromId(171);
    }
    /**
		Returns 09324 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndTwentyFour(): IMilitaryZipCode {
        return this.FromId(172);
    }
    /**
		Returns 09325 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndTwentyFive(): IMilitaryZipCode {
        return this.FromId(173);
    }
    /**
		Returns 09326 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndTwentySix(): IMilitaryZipCode {
        return this.FromId(174);
    }
    /**
		Returns 09330 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndThirty(): IMilitaryZipCode {
        return this.FromId(175);
    }
    /**
		Returns 09331 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndThirtyOne(): IMilitaryZipCode {
        return this.FromId(176);
    }
    /**
		Returns 09332 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndThirtyTwo(): IMilitaryZipCode {
        return this.FromId(177);
    }
    /**
		Returns 09333 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndThirtyThree(): IMilitaryZipCode {
        return this.FromId(178);
    }
    /**
		Returns 09334 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndThirtyFour(): IMilitaryZipCode {
        return this.FromId(179);
    }
    /**
		Returns 09335 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndThirtyFive(): IMilitaryZipCode {
        return this.FromId(180);
    }
    /**
		Returns 09340 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndForty(): IMilitaryZipCode {
        return this.FromId(181);
    }
    /**
		Returns 09342 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndFortyTwo(): IMilitaryZipCode {
        return this.FromId(182);
    }
    /**
		Returns 09344 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndFortyFour(): IMilitaryZipCode {
        return this.FromId(183);
    }
    /**
		Returns 09347 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndFortySeven(): IMilitaryZipCode {
        return this.FromId(184);
    }
    /**
		Returns 09348 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndFortyEight(): IMilitaryZipCode {
        return this.FromId(185);
    }
    /**
		Returns 09351 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndFiftyOne(): IMilitaryZipCode {
        return this.FromId(186);
    }
    /**
		Returns 09352 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndFiftyTwo(): IMilitaryZipCode {
        return this.FromId(187);
    }
    /**
		Returns 09353 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndFiftyThree(): IMilitaryZipCode {
        return this.FromId(188);
    }
    /**
		Returns 09354 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndFiftyFour(): IMilitaryZipCode {
        return this.FromId(189);
    }
    /**
		Returns 09355 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndFiftyFive(): IMilitaryZipCode {
        return this.FromId(190);
    }
    /**
		Returns 09358 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndFiftyEight(): IMilitaryZipCode {
        return this.FromId(191);
    }
    /**
		Returns 09360 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndSixty(): IMilitaryZipCode {
        return this.FromId(192);
    }
    /**
		Returns 09361 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndSixtyOne(): IMilitaryZipCode {
        return this.FromId(193);
    }
    /**
		Returns 09366 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndSixtySix(): IMilitaryZipCode {
        return this.FromId(194);
    }
    /**
		Returns 09368 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndSixtyEight(): IMilitaryZipCode {
        return this.FromId(195);
    }
    /**
		Returns 09375 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndSeventyFive(): IMilitaryZipCode {
        return this.FromId(196);
    }
    /**
		Returns 09376 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndSeventySix(): IMilitaryZipCode {
        return this.FromId(197);
    }
    /**
		Returns 09378 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndSeventyEight(): IMilitaryZipCode {
        return this.FromId(198);
    }
    /**
		Returns 09379 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndSeventyNine(): IMilitaryZipCode {
        return this.FromId(199);
    }
    /**
		Returns 09384 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndEightyFour(): IMilitaryZipCode {
        return this.FromId(200);
    }
    /**
		Returns 09390 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndNinety(): IMilitaryZipCode {
        return this.FromId(201);
    }
    /**
		Returns 09391 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndNinetyOne(): IMilitaryZipCode {
        return this.FromId(202);
    }
    /**
		Returns 09392 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndNinetyTwo(): IMilitaryZipCode {
        return this.FromId(203);
    }
    /**
		Returns 09393 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndNinetyThree(): IMilitaryZipCode {
        return this.FromId(204);
    }
    /**
		Returns 09394 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndNinetyFour(): IMilitaryZipCode {
        return this.FromId(205);
    }
    /**
		Returns 09396 MilitaryZipCode
	**/
    get NineThousandThreeHundredAndNinetySix(): IMilitaryZipCode {
        return this.FromId(206);
    }
    /**
		Returns 09403 MilitaryZipCode
	**/
    get NineThousandFourHundredAndThree(): IMilitaryZipCode {
        return this.FromId(207);
    }
    /**
		Returns 09405 MilitaryZipCode
	**/
    get NineThousandFourHundredAndFive(): IMilitaryZipCode {
        return this.FromId(208);
    }
    /**
		Returns 09406 MilitaryZipCode
	**/
    get NineThousandFourHundredAndSix(): IMilitaryZipCode {
        return this.FromId(209);
    }
    /**
		Returns 09407 MilitaryZipCode
	**/
    get NineThousandFourHundredAndSeven(): IMilitaryZipCode {
        return this.FromId(210);
    }
    /**
		Returns 09409 MilitaryZipCode
	**/
    get NineThousandFourHundredAndNine(): IMilitaryZipCode {
        return this.FromId(211);
    }
    /**
		Returns 09411 MilitaryZipCode
	**/
    get NineThousandFourHundredAndEleven(): IMilitaryZipCode {
        return this.FromId(212);
    }
    /**
		Returns 09419 MilitaryZipCode
	**/
    get NineThousandFourHundredAndNineteen(): IMilitaryZipCode {
        return this.FromId(213);
    }
    /**
		Returns 09420 MilitaryZipCode
	**/
    get NineThousandFourHundredAndTwenty(): IMilitaryZipCode {
        return this.FromId(214);
    }
    /**
		Returns 09421 MilitaryZipCode
	**/
    get NineThousandFourHundredAndTwentyOne(): IMilitaryZipCode {
        return this.FromId(215);
    }
    /**
		Returns 09447 MilitaryZipCode
	**/
    get NineThousandFourHundredAndFortySeven(): IMilitaryZipCode {
        return this.FromId(216);
    }
    /**
		Returns 09449 MilitaryZipCode
	**/
    get NineThousandFourHundredAndFortyNine(): IMilitaryZipCode {
        return this.FromId(217);
    }
    /**
		Returns 09451 MilitaryZipCode
	**/
    get NineThousandFourHundredAndFiftyOne(): IMilitaryZipCode {
        return this.FromId(218);
    }
    /**
		Returns 09452 MilitaryZipCode
	**/
    get NineThousandFourHundredAndFiftyTwo(): IMilitaryZipCode {
        return this.FromId(219);
    }
    /**
		Returns 09454 MilitaryZipCode
	**/
    get NineThousandFourHundredAndFiftyFour(): IMilitaryZipCode {
        return this.FromId(220);
    }
    /**
		Returns 09455 MilitaryZipCode
	**/
    get NineThousandFourHundredAndFiftyFive(): IMilitaryZipCode {
        return this.FromId(221);
    }
    /**
		Returns 09456 MilitaryZipCode
	**/
    get NineThousandFourHundredAndFiftySix(): IMilitaryZipCode {
        return this.FromId(222);
    }
    /**
		Returns 09457 MilitaryZipCode
	**/
    get NineThousandFourHundredAndFiftySeven(): IMilitaryZipCode {
        return this.FromId(223);
    }
    /**
		Returns 09458 MilitaryZipCode
	**/
    get NineThousandFourHundredAndFiftyEight(): IMilitaryZipCode {
        return this.FromId(224);
    }
    /**
		Returns 09459 MilitaryZipCode
	**/
    get NineThousandFourHundredAndFiftyNine(): IMilitaryZipCode {
        return this.FromId(225);
    }
    /**
		Returns 09464 MilitaryZipCode
	**/
    get NineThousandFourHundredAndSixtyFour(): IMilitaryZipCode {
        return this.FromId(226);
    }
    /**
		Returns 09465 MilitaryZipCode
	**/
    get NineThousandFourHundredAndSixtyFive(): IMilitaryZipCode {
        return this.FromId(227);
    }
    /**
		Returns 09466 MilitaryZipCode
	**/
    get NineThousandFourHundredAndSixtySix(): IMilitaryZipCode {
        return this.FromId(228);
    }
    /**
		Returns 09468 MilitaryZipCode
	**/
    get NineThousandFourHundredAndSixtyEight(): IMilitaryZipCode {
        return this.FromId(229);
    }
    /**
		Returns 09469 MilitaryZipCode
	**/
    get NineThousandFourHundredAndSixtyNine(): IMilitaryZipCode {
        return this.FromId(230);
    }
    /**
		Returns 09470 MilitaryZipCode
	**/
    get NineThousandFourHundredAndSeventy(): IMilitaryZipCode {
        return this.FromId(231);
    }
    /**
		Returns 09494 MilitaryZipCode
	**/
    get NineThousandFourHundredAndNinetyFour(): IMilitaryZipCode {
        return this.FromId(232);
    }
    /**
		Returns 09498 MilitaryZipCode
	**/
    get NineThousandFourHundredAndNinetyEight(): IMilitaryZipCode {
        return this.FromId(233);
    }
    /**
		Returns 09499 MilitaryZipCode
	**/
    get NineThousandFourHundredAndNinetyNine(): IMilitaryZipCode {
        return this.FromId(234);
    }
    /**
		Returns 09503 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndThree(): IMilitaryZipCode {
        return this.FromId(235);
    }
    /**
		Returns 09507 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndSeven(): IMilitaryZipCode {
        return this.FromId(236);
    }
    /**
		Returns 09508 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndEight(): IMilitaryZipCode {
        return this.FromId(237);
    }
    /**
		Returns 09509 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndNine(): IMilitaryZipCode {
        return this.FromId(238);
    }
    /**
		Returns 09510 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndTen(): IMilitaryZipCode {
        return this.FromId(239);
    }
    /**
		Returns 09512 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndTwelve(): IMilitaryZipCode {
        return this.FromId(240);
    }
    /**
		Returns 09513 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndThirteen(): IMilitaryZipCode {
        return this.FromId(241);
    }
    /**
		Returns 09517 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndSeventeen(): IMilitaryZipCode {
        return this.FromId(242);
    }
    /**
		Returns 09518 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndEighteen(): IMilitaryZipCode {
        return this.FromId(243);
    }
    /**
		Returns 09519 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndNineteen(): IMilitaryZipCode {
        return this.FromId(244);
    }
    /**
		Returns 09520 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndTwenty(): IMilitaryZipCode {
        return this.FromId(245);
    }
    /**
		Returns 09521 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndTwentyOne(): IMilitaryZipCode {
        return this.FromId(246);
    }
    /**
		Returns 09522 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndTwentyTwo(): IMilitaryZipCode {
        return this.FromId(247);
    }
    /**
		Returns 09523 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndTwentyThree(): IMilitaryZipCode {
        return this.FromId(248);
    }
    /**
		Returns 09524 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndTwentyFour(): IMilitaryZipCode {
        return this.FromId(249);
    }
    /**
		Returns 09527 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndTwentySeven(): IMilitaryZipCode {
        return this.FromId(250);
    }
    /**
		Returns 09529 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndTwentyNine(): IMilitaryZipCode {
        return this.FromId(251);
    }
    /**
		Returns 09531 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndThirtyOne(): IMilitaryZipCode {
        return this.FromId(252);
    }
    /**
		Returns 09532 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndThirtyTwo(): IMilitaryZipCode {
        return this.FromId(253);
    }
    /**
		Returns 09533 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndThirtyThree(): IMilitaryZipCode {
        return this.FromId(254);
    }
    /**
		Returns 09534 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndThirtyFour(): IMilitaryZipCode {
        return this.FromId(255);
    }
    /**
		Returns 09536 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndThirtySix(): IMilitaryZipCode {
        return this.FromId(256);
    }
    /**
		Returns 09537 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndThirtySeven(): IMilitaryZipCode {
        return this.FromId(257);
    }
    /**
		Returns 09538 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndThirtyEight(): IMilitaryZipCode {
        return this.FromId(258);
    }
    /**
		Returns 09539 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndThirtyNine(): IMilitaryZipCode {
        return this.FromId(259);
    }
    /**
		Returns 09540 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndForty(): IMilitaryZipCode {
        return this.FromId(260);
    }
    /**
		Returns 09542 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndFortyTwo(): IMilitaryZipCode {
        return this.FromId(261);
    }
    /**
		Returns 09543 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndFortyThree(): IMilitaryZipCode {
        return this.FromId(262);
    }
    /**
		Returns 09544 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndFortyFour(): IMilitaryZipCode {
        return this.FromId(263);
    }
    /**
		Returns 09545 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndFortyFive(): IMilitaryZipCode {
        return this.FromId(264);
    }
    /**
		Returns 09547 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndFortySeven(): IMilitaryZipCode {
        return this.FromId(265);
    }
    /**
		Returns 09548 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndFortyEight(): IMilitaryZipCode {
        return this.FromId(266);
    }
    /**
		Returns 09549 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndFortyNine(): IMilitaryZipCode {
        return this.FromId(267);
    }
    /**
		Returns 09550 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndFifty(): IMilitaryZipCode {
        return this.FromId(268);
    }
    /**
		Returns 09551 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndFiftyOne(): IMilitaryZipCode {
        return this.FromId(269);
    }
    /**
		Returns 09552 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndFiftyTwo(): IMilitaryZipCode {
        return this.FromId(270);
    }
    /**
		Returns 09556 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndFiftySix(): IMilitaryZipCode {
        return this.FromId(271);
    }
    /**
		Returns 09557 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndFiftySeven(): IMilitaryZipCode {
        return this.FromId(272);
    }
    /**
		Returns 09559 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndFiftyNine(): IMilitaryZipCode {
        return this.FromId(273);
    }
    /**
		Returns 09560 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndSixty(): IMilitaryZipCode {
        return this.FromId(274);
    }
    /**
		Returns 09561 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndSixtyOne(): IMilitaryZipCode {
        return this.FromId(275);
    }
    /**
		Returns 09564 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndSixtyFour(): IMilitaryZipCode {
        return this.FromId(276);
    }
    /**
		Returns 09565 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndSixtyFive(): IMilitaryZipCode {
        return this.FromId(277);
    }
    /**
		Returns 09566 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndSixtySix(): IMilitaryZipCode {
        return this.FromId(278);
    }
    /**
		Returns 09567 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndSixtySeven(): IMilitaryZipCode {
        return this.FromId(279);
    }
    /**
		Returns 09568 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndSixtyEight(): IMilitaryZipCode {
        return this.FromId(280);
    }
    /**
		Returns 09570 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndSeventy(): IMilitaryZipCode {
        return this.FromId(281);
    }
    /**
		Returns 09571 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndSeventyOne(): IMilitaryZipCode {
        return this.FromId(282);
    }
    /**
		Returns 09573 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndSeventyThree(): IMilitaryZipCode {
        return this.FromId(283);
    }
    /**
		Returns 09576 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndSeventySix(): IMilitaryZipCode {
        return this.FromId(284);
    }
    /**
		Returns 09577 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndSeventySeven(): IMilitaryZipCode {
        return this.FromId(285);
    }
    /**
		Returns 09578 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndSeventyEight(): IMilitaryZipCode {
        return this.FromId(286);
    }
    /**
		Returns 09579 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndSeventyNine(): IMilitaryZipCode {
        return this.FromId(287);
    }
    /**
		Returns 09582 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndEightyTwo(): IMilitaryZipCode {
        return this.FromId(288);
    }
    /**
		Returns 09586 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndEightySix(): IMilitaryZipCode {
        return this.FromId(289);
    }
    /**
		Returns 09587 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndEightySeven(): IMilitaryZipCode {
        return this.FromId(290);
    }
    /**
		Returns 09588 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndEightyEight(): IMilitaryZipCode {
        return this.FromId(291);
    }
    /**
		Returns 09589 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndEightyNine(): IMilitaryZipCode {
        return this.FromId(292);
    }
    /**
		Returns 09590 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndNinety(): IMilitaryZipCode {
        return this.FromId(293);
    }
    /**
		Returns 09591 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndNinetyOne(): IMilitaryZipCode {
        return this.FromId(294);
    }
    /**
		Returns 09593 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndNinetyThree(): IMilitaryZipCode {
        return this.FromId(295);
    }
    /**
		Returns 09594 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndNinetyFour(): IMilitaryZipCode {
        return this.FromId(296);
    }
    /**
		Returns 09595 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndNinetyFive(): IMilitaryZipCode {
        return this.FromId(297);
    }
    /**
		Returns 09597 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndNinetySeven(): IMilitaryZipCode {
        return this.FromId(298);
    }
    /**
		Returns 09599 MilitaryZipCode
	**/
    get NineThousandFiveHundredAndNinetyNine(): IMilitaryZipCode {
        return this.FromId(299);
    }
    /**
		Returns 09601 MilitaryZipCode
	**/
    get NineThousandSixHundredAndOne(): IMilitaryZipCode {
        return this.FromId(300);
    }
    /**
		Returns 09603 MilitaryZipCode
	**/
    get NineThousandSixHundredAndThree(): IMilitaryZipCode {
        return this.FromId(301);
    }
    /**
		Returns 09605 MilitaryZipCode
	**/
    get NineThousandSixHundredAndFive(): IMilitaryZipCode {
        return this.FromId(302);
    }
    /**
		Returns 09607 MilitaryZipCode
	**/
    get NineThousandSixHundredAndSeven(): IMilitaryZipCode {
        return this.FromId(303);
    }
    /**
		Returns 09608 MilitaryZipCode
	**/
    get NineThousandSixHundredAndEight(): IMilitaryZipCode {
        return this.FromId(304);
    }
    /**
		Returns 09609 MilitaryZipCode
	**/
    get NineThousandSixHundredAndNine(): IMilitaryZipCode {
        return this.FromId(305);
    }
    /**
		Returns 09610 MilitaryZipCode
	**/
    get NineThousandSixHundredAndTen(): IMilitaryZipCode {
        return this.FromId(306);
    }
    /**
		Returns 09612 MilitaryZipCode
	**/
    get NineThousandSixHundredAndTwelve(): IMilitaryZipCode {
        return this.FromId(307);
    }
    /**
		Returns 09613 MilitaryZipCode
	**/
    get NineThousandSixHundredAndThirteen(): IMilitaryZipCode {
        return this.FromId(308);
    }
    /**
		Returns 09616 MilitaryZipCode
	**/
    get NineThousandSixHundredAndSixteen(): IMilitaryZipCode {
        return this.FromId(309);
    }
    /**
		Returns 09617 MilitaryZipCode
	**/
    get NineThousandSixHundredAndSeventeen(): IMilitaryZipCode {
        return this.FromId(310);
    }
    /**
		Returns 09618 MilitaryZipCode
	**/
    get NineThousandSixHundredAndEighteen(): IMilitaryZipCode {
        return this.FromId(311);
    }
    /**
		Returns 09619 MilitaryZipCode
	**/
    get NineThousandSixHundredAndNineteen(): IMilitaryZipCode {
        return this.FromId(312);
    }
    /**
		Returns 09620 MilitaryZipCode
	**/
    get NineThousandSixHundredAndTwenty(): IMilitaryZipCode {
        return this.FromId(313);
    }
    /**
		Returns 09621 MilitaryZipCode
	**/
    get NineThousandSixHundredAndTwentyOne(): IMilitaryZipCode {
        return this.FromId(314);
    }
    /**
		Returns 09622 MilitaryZipCode
	**/
    get NineThousandSixHundredAndTwentyTwo(): IMilitaryZipCode {
        return this.FromId(315);
    }
    /**
		Returns 09623 MilitaryZipCode
	**/
    get NineThousandSixHundredAndTwentyThree(): IMilitaryZipCode {
        return this.FromId(316);
    }
    /**
		Returns 09624 MilitaryZipCode
	**/
    get NineThousandSixHundredAndTwentyFour(): IMilitaryZipCode {
        return this.FromId(317);
    }
    /**
		Returns 09625 MilitaryZipCode
	**/
    get NineThousandSixHundredAndTwentyFive(): IMilitaryZipCode {
        return this.FromId(318);
    }
    /**
		Returns 09626 MilitaryZipCode
	**/
    get NineThousandSixHundredAndTwentySix(): IMilitaryZipCode {
        return this.FromId(319);
    }
    /**
		Returns 09627 MilitaryZipCode
	**/
    get NineThousandSixHundredAndTwentySeven(): IMilitaryZipCode {
        return this.FromId(320);
    }
    /**
		Returns 09628 MilitaryZipCode
	**/
    get NineThousandSixHundredAndTwentyEight(): IMilitaryZipCode {
        return this.FromId(321);
    }
    /**
		Returns 09630 MilitaryZipCode
	**/
    get NineThousandSixHundredAndThirty(): IMilitaryZipCode {
        return this.FromId(322);
    }
    /**
		Returns 09633 MilitaryZipCode
	**/
    get NineThousandSixHundredAndThirtyThree(): IMilitaryZipCode {
        return this.FromId(323);
    }
    /**
		Returns 09636 MilitaryZipCode
	**/
    get NineThousandSixHundredAndThirtySix(): IMilitaryZipCode {
        return this.FromId(324);
    }
    /**
		Returns 09642 MilitaryZipCode
	**/
    get NineThousandSixHundredAndFortyTwo(): IMilitaryZipCode {
        return this.FromId(325);
    }
    /**
		Returns 09643 MilitaryZipCode
	**/
    get NineThousandSixHundredAndFortyThree(): IMilitaryZipCode {
        return this.FromId(326);
    }
    /**
		Returns 09644 MilitaryZipCode
	**/
    get NineThousandSixHundredAndFortyFour(): IMilitaryZipCode {
        return this.FromId(327);
    }
    /**
		Returns 09645 MilitaryZipCode
	**/
    get NineThousandSixHundredAndFortyFive(): IMilitaryZipCode {
        return this.FromId(328);
    }
    /**
		Returns 09648 MilitaryZipCode
	**/
    get NineThousandSixHundredAndFortyEight(): IMilitaryZipCode {
        return this.FromId(329);
    }
    /**
		Returns 09649 MilitaryZipCode
	**/
    get NineThousandSixHundredAndFortyNine(): IMilitaryZipCode {
        return this.FromId(330);
    }
    /**
		Returns 09657 MilitaryZipCode
	**/
    get NineThousandSixHundredAndFiftySeven(): IMilitaryZipCode {
        return this.FromId(331);
    }
    /**
		Returns 09667 MilitaryZipCode
	**/
    get NineThousandSixHundredAndSixtySeven(): IMilitaryZipCode {
        return this.FromId(332);
    }
    /**
		Returns 09668 MilitaryZipCode
	**/
    get NineThousandSixHundredAndSixtyEight(): IMilitaryZipCode {
        return this.FromId(333);
    }
    /**
		Returns 09669 MilitaryZipCode
	**/
    get NineThousandSixHundredAndSixtyNine(): IMilitaryZipCode {
        return this.FromId(334);
    }
    /**
		Returns 09672 MilitaryZipCode
	**/
    get NineThousandSixHundredAndSeventyTwo(): IMilitaryZipCode {
        return this.FromId(335);
    }
    /**
		Returns 09673 MilitaryZipCode
	**/
    get NineThousandSixHundredAndSeventyThree(): IMilitaryZipCode {
        return this.FromId(336);
    }
    /**
		Returns 09690 MilitaryZipCode
	**/
    get NineThousandSixHundredAndNinety(): IMilitaryZipCode {
        return this.FromId(337);
    }
    /**
		Returns 09692 MilitaryZipCode
	**/
    get NineThousandSixHundredAndNinetyTwo(): IMilitaryZipCode {
        return this.FromId(338);
    }
    /**
		Returns 09694 MilitaryZipCode
	**/
    get NineThousandSixHundredAndNinetyFour(): IMilitaryZipCode {
        return this.FromId(339);
    }
    /**
		Returns 09696 MilitaryZipCode
	**/
    get NineThousandSixHundredAndNinetySix(): IMilitaryZipCode {
        return this.FromId(340);
    }
    /**
		Returns 09697 MilitaryZipCode
	**/
    get NineThousandSixHundredAndNinetySeven(): IMilitaryZipCode {
        return this.FromId(341);
    }
    /**
		Returns 09701 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndOne(): IMilitaryZipCode {
        return this.FromId(342);
    }
    /**
		Returns 09702 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndTwo(): IMilitaryZipCode {
        return this.FromId(343);
    }
    /**
		Returns 09703 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndThree(): IMilitaryZipCode {
        return this.FromId(344);
    }
    /**
		Returns 09704 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndFour(): IMilitaryZipCode {
        return this.FromId(345);
    }
    /**
		Returns 09705 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndFive(): IMilitaryZipCode {
        return this.FromId(346);
    }
    /**
		Returns 09706 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndSix(): IMilitaryZipCode {
        return this.FromId(347);
    }
    /**
		Returns 09707 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndSeven(): IMilitaryZipCode {
        return this.FromId(348);
    }
    /**
		Returns 09708 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndEight(): IMilitaryZipCode {
        return this.FromId(349);
    }
    /**
		Returns 09710 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndTen(): IMilitaryZipCode {
        return this.FromId(350);
    }
    /**
		Returns 09712 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndTwelve(): IMilitaryZipCode {
        return this.FromId(351);
    }
    /**
		Returns 09714 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndFourteen(): IMilitaryZipCode {
        return this.FromId(352);
    }
    /**
		Returns 09715 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndFifteen(): IMilitaryZipCode {
        return this.FromId(353);
    }
    /**
		Returns 09717 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndSeventeen(): IMilitaryZipCode {
        return this.FromId(354);
    }
    /**
		Returns 09718 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndEighteen(): IMilitaryZipCode {
        return this.FromId(355);
    }
    /**
		Returns 09719 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndNineteen(): IMilitaryZipCode {
        return this.FromId(356);
    }
    /**
		Returns 09720 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndTwenty(): IMilitaryZipCode {
        return this.FromId(357);
    }
    /**
		Returns 09721 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndTwentyOne(): IMilitaryZipCode {
        return this.FromId(358);
    }
    /**
		Returns 09723 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndTwentyThree(): IMilitaryZipCode {
        return this.FromId(359);
    }
    /**
		Returns 09724 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndTwentyFour(): IMilitaryZipCode {
        return this.FromId(360);
    }
    /**
		Returns 09725 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndTwentyFive(): IMilitaryZipCode {
        return this.FromId(361);
    }
    /**
		Returns 09728 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndTwentyEight(): IMilitaryZipCode {
        return this.FromId(362);
    }
    /**
		Returns 09730 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndThirty(): IMilitaryZipCode {
        return this.FromId(363);
    }
    /**
		Returns 09731 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndThirtyOne(): IMilitaryZipCode {
        return this.FromId(364);
    }
    /**
		Returns 09732 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndThirtyTwo(): IMilitaryZipCode {
        return this.FromId(365);
    }
    /**
		Returns 09734 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndThirtyFour(): IMilitaryZipCode {
        return this.FromId(366);
    }
    /**
		Returns 09736 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndThirtySix(): IMilitaryZipCode {
        return this.FromId(367);
    }
    /**
		Returns 09737 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndThirtySeven(): IMilitaryZipCode {
        return this.FromId(368);
    }
    /**
		Returns 09739 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndThirtyNine(): IMilitaryZipCode {
        return this.FromId(369);
    }
    /**
		Returns 09742 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndFortyTwo(): IMilitaryZipCode {
        return this.FromId(370);
    }
    /**
		Returns 09743 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndFortyThree(): IMilitaryZipCode {
        return this.FromId(371);
    }
    /**
		Returns 09744 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndFortyFour(): IMilitaryZipCode {
        return this.FromId(372);
    }
    /**
		Returns 09751 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndFiftyOne(): IMilitaryZipCode {
        return this.FromId(373);
    }
    /**
		Returns 09752 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndFiftyTwo(): IMilitaryZipCode {
        return this.FromId(374);
    }
    /**
		Returns 09754 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndFiftyFour(): IMilitaryZipCode {
        return this.FromId(375);
    }
    /**
		Returns 09755 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndFiftyFive(): IMilitaryZipCode {
        return this.FromId(376);
    }
    /**
		Returns 09757 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndFiftySeven(): IMilitaryZipCode {
        return this.FromId(377);
    }
    /**
		Returns 09762 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndSixtyTwo(): IMilitaryZipCode {
        return this.FromId(378);
    }
    /**
		Returns 09769 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndSixtyNine(): IMilitaryZipCode {
        return this.FromId(379);
    }
    /**
		Returns 09777 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndSeventySeven(): IMilitaryZipCode {
        return this.FromId(380);
    }
    /**
		Returns 09786 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndEightySix(): IMilitaryZipCode {
        return this.FromId(381);
    }
    /**
		Returns 09789 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndEightyNine(): IMilitaryZipCode {
        return this.FromId(382);
    }
    /**
		Returns 09790 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndNinety(): IMilitaryZipCode {
        return this.FromId(383);
    }
    /**
		Returns 09794 MilitaryZipCode
	**/
    get NineThousandSevenHundredAndNinetyFour(): IMilitaryZipCode {
        return this.FromId(384);
    }
    /**
		Returns 09801 MilitaryZipCode
	**/
    get NineThousandEightHundredAndOne(): IMilitaryZipCode {
        return this.FromId(385);
    }
    /**
		Returns 09803 MilitaryZipCode
	**/
    get NineThousandEightHundredAndThree(): IMilitaryZipCode {
        return this.FromId(386);
    }
    /**
		Returns 09806 MilitaryZipCode
	**/
    get NineThousandEightHundredAndSix(): IMilitaryZipCode {
        return this.FromId(387);
    }
    /**
		Returns 09809 MilitaryZipCode
	**/
    get NineThousandEightHundredAndNine(): IMilitaryZipCode {
        return this.FromId(388);
    }
    /**
		Returns 09812 MilitaryZipCode
	**/
    get NineThousandEightHundredAndTwelve(): IMilitaryZipCode {
        return this.FromId(389);
    }
    /**
		Returns 09817 MilitaryZipCode
	**/
    get NineThousandEightHundredAndSeventeen(): IMilitaryZipCode {
        return this.FromId(390);
    }
    /**
		Returns 09821 MilitaryZipCode
	**/
    get NineThousandEightHundredAndTwentyOne(): IMilitaryZipCode {
        return this.FromId(391);
    }
    /**
		Returns 09822 MilitaryZipCode
	**/
    get NineThousandEightHundredAndTwentyTwo(): IMilitaryZipCode {
        return this.FromId(392);
    }
    /**
		Returns 09823 MilitaryZipCode
	**/
    get NineThousandEightHundredAndTwentyThree(): IMilitaryZipCode {
        return this.FromId(393);
    }
    /**
		Returns 09824 MilitaryZipCode
	**/
    get NineThousandEightHundredAndTwentyFour(): IMilitaryZipCode {
        return this.FromId(394);
    }
    /**
		Returns 09825 MilitaryZipCode
	**/
    get NineThousandEightHundredAndTwentyFive(): IMilitaryZipCode {
        return this.FromId(395);
    }
    /**
		Returns 09827 MilitaryZipCode
	**/
    get NineThousandEightHundredAndTwentySeven(): IMilitaryZipCode {
        return this.FromId(396);
    }
    /**
		Returns 09828 MilitaryZipCode
	**/
    get NineThousandEightHundredAndTwentyEight(): IMilitaryZipCode {
        return this.FromId(397);
    }
    /**
		Returns 09830 MilitaryZipCode
	**/
    get NineThousandEightHundredAndThirty(): IMilitaryZipCode {
        return this.FromId(398);
    }
    /**
		Returns 09831 MilitaryZipCode
	**/
    get NineThousandEightHundredAndThirtyOne(): IMilitaryZipCode {
        return this.FromId(399);
    }
    /**
		Returns 09833 MilitaryZipCode
	**/
    get NineThousandEightHundredAndThirtyThree(): IMilitaryZipCode {
        return this.FromId(400);
    }
    /**
		Returns 09834 MilitaryZipCode
	**/
    get NineThousandEightHundredAndThirtyFour(): IMilitaryZipCode {
        return this.FromId(401);
    }
    /**
		Returns 09836 MilitaryZipCode
	**/
    get NineThousandEightHundredAndThirtySix(): IMilitaryZipCode {
        return this.FromId(402);
    }
    /**
		Returns 09838 MilitaryZipCode
	**/
    get NineThousandEightHundredAndThirtyEight(): IMilitaryZipCode {
        return this.FromId(403);
    }
    /**
		Returns 09839 MilitaryZipCode
	**/
    get NineThousandEightHundredAndThirtyNine(): IMilitaryZipCode {
        return this.FromId(404);
    }
    /**
		Returns 09841 MilitaryZipCode
	**/
    get NineThousandEightHundredAndFortyOne(): IMilitaryZipCode {
        return this.FromId(405);
    }
    /**
		Returns 09842 MilitaryZipCode
	**/
    get NineThousandEightHundredAndFortyTwo(): IMilitaryZipCode {
        return this.FromId(406);
    }
    /**
		Returns 09843 MilitaryZipCode
	**/
    get NineThousandEightHundredAndFortyThree(): IMilitaryZipCode {
        return this.FromId(407);
    }
    /**
		Returns 09846 MilitaryZipCode
	**/
    get NineThousandEightHundredAndFortySix(): IMilitaryZipCode {
        return this.FromId(408);
    }
    /**
		Returns 09852 MilitaryZipCode
	**/
    get NineThousandEightHundredAndFiftyTwo(): IMilitaryZipCode {
        return this.FromId(409);
    }
    /**
		Returns 09858 MilitaryZipCode
	**/
    get NineThousandEightHundredAndFiftyEight(): IMilitaryZipCode {
        return this.FromId(410);
    }
    /**
		Returns 09860 MilitaryZipCode
	**/
    get NineThousandEightHundredAndSixty(): IMilitaryZipCode {
        return this.FromId(411);
    }
    /**
		Returns 09865 MilitaryZipCode
	**/
    get NineThousandEightHundredAndSixtyFive(): IMilitaryZipCode {
        return this.FromId(412);
    }
    /**
		Returns 09870 MilitaryZipCode
	**/
    get NineThousandEightHundredAndSeventy(): IMilitaryZipCode {
        return this.FromId(413);
    }
    /**
		Returns 09880 MilitaryZipCode
	**/
    get NineThousandEightHundredAndEighty(): IMilitaryZipCode {
        return this.FromId(414);
    }
    /**
		Returns 09881 MilitaryZipCode
	**/
    get NineThousandEightHundredAndEightyOne(): IMilitaryZipCode {
        return this.FromId(415);
    }
    /**
		Returns 09889 MilitaryZipCode
	**/
    get NineThousandEightHundredAndEightyNine(): IMilitaryZipCode {
        return this.FromId(416);
    }
    /**
		Returns 09890 MilitaryZipCode
	**/
    get NineThousandEightHundredAndNinety(): IMilitaryZipCode {
        return this.FromId(417);
    }
    /**
		Returns 09892 MilitaryZipCode
	**/
    get NineThousandEightHundredAndNinetyTwo(): IMilitaryZipCode {
        return this.FromId(418);
    }
    /**
		Returns 09898 MilitaryZipCode
	**/
    get NineThousandEightHundredAndNinetyEight(): IMilitaryZipCode {
        return this.FromId(419);
    }
    /**
		Returns 34001 MilitaryZipCode
	**/
    get ThirtyFourThousandAndOne(): IMilitaryZipCode {
        return this.FromId(420);
    }
    /**
		Returns 34002 MilitaryZipCode
	**/
    get ThirtyFourThousandAndTwo(): IMilitaryZipCode {
        return this.FromId(421);
    }
    /**
		Returns 34003 MilitaryZipCode
	**/
    get ThirtyFourThousandAndThree(): IMilitaryZipCode {
        return this.FromId(422);
    }
    /**
		Returns 34004 MilitaryZipCode
	**/
    get ThirtyFourThousandAndFour(): IMilitaryZipCode {
        return this.FromId(423);
    }
    /**
		Returns 34005 MilitaryZipCode
	**/
    get ThirtyFourThousandAndFive(): IMilitaryZipCode {
        return this.FromId(424);
    }
    /**
		Returns 34007 MilitaryZipCode
	**/
    get ThirtyFourThousandAndSeven(): IMilitaryZipCode {
        return this.FromId(425);
    }
    /**
		Returns 34020 MilitaryZipCode
	**/
    get ThirtyFourThousandAndTwenty(): IMilitaryZipCode {
        return this.FromId(426);
    }
    /**
		Returns 34021 MilitaryZipCode
	**/
    get ThirtyFourThousandAndTwentyOne(): IMilitaryZipCode {
        return this.FromId(427);
    }
    /**
		Returns 34022 MilitaryZipCode
	**/
    get ThirtyFourThousandAndTwentyTwo(): IMilitaryZipCode {
        return this.FromId(428);
    }
    /**
		Returns 34023 MilitaryZipCode
	**/
    get ThirtyFourThousandAndTwentyThree(): IMilitaryZipCode {
        return this.FromId(429);
    }
    /**
		Returns 34024 MilitaryZipCode
	**/
    get ThirtyFourThousandAndTwentyFour(): IMilitaryZipCode {
        return this.FromId(430);
    }
    /**
		Returns 34030 MilitaryZipCode
	**/
    get ThirtyFourThousandAndThirty(): IMilitaryZipCode {
        return this.FromId(431);
    }
    /**
		Returns 34031 MilitaryZipCode
	**/
    get ThirtyFourThousandAndThirtyOne(): IMilitaryZipCode {
        return this.FromId(432);
    }
    /**
		Returns 34032 MilitaryZipCode
	**/
    get ThirtyFourThousandAndThirtyTwo(): IMilitaryZipCode {
        return this.FromId(433);
    }
    /**
		Returns 34033 MilitaryZipCode
	**/
    get ThirtyFourThousandAndThirtyThree(): IMilitaryZipCode {
        return this.FromId(434);
    }
    /**
		Returns 34034 MilitaryZipCode
	**/
    get ThirtyFourThousandAndThirtyFour(): IMilitaryZipCode {
        return this.FromId(435);
    }
    /**
		Returns 34035 MilitaryZipCode
	**/
    get ThirtyFourThousandAndThirtyFive(): IMilitaryZipCode {
        return this.FromId(436);
    }
    /**
		Returns 34037 MilitaryZipCode
	**/
    get ThirtyFourThousandAndThirtySeven(): IMilitaryZipCode {
        return this.FromId(437);
    }
    /**
		Returns 34038 MilitaryZipCode
	**/
    get ThirtyFourThousandAndThirtyEight(): IMilitaryZipCode {
        return this.FromId(438);
    }
    /**
		Returns 34039 MilitaryZipCode
	**/
    get ThirtyFourThousandAndThirtyNine(): IMilitaryZipCode {
        return this.FromId(439);
    }
    /**
		Returns 34042 MilitaryZipCode
	**/
    get ThirtyFourThousandAndFortyTwo(): IMilitaryZipCode {
        return this.FromId(440);
    }
    /**
		Returns 34051 MilitaryZipCode
	**/
    get ThirtyFourThousandAndFiftyOne(): IMilitaryZipCode {
        return this.FromId(441);
    }
    /**
		Returns 34053 MilitaryZipCode
	**/
    get ThirtyFourThousandAndFiftyThree(): IMilitaryZipCode {
        return this.FromId(442);
    }
    /**
		Returns 34058 MilitaryZipCode
	**/
    get ThirtyFourThousandAndFiftyEight(): IMilitaryZipCode {
        return this.FromId(443);
    }
    /**
		Returns 34061 MilitaryZipCode
	**/
    get ThirtyFourThousandAndSixtyOne(): IMilitaryZipCode {
        return this.FromId(444);
    }
    /**
		Returns 34078 MilitaryZipCode
	**/
    get ThirtyFourThousandAndSeventyEight(): IMilitaryZipCode {
        return this.FromId(445);
    }
    /**
		Returns 34080 MilitaryZipCode
	**/
    get ThirtyFourThousandAndEighty(): IMilitaryZipCode {
        return this.FromId(446);
    }
    /**
		Returns 34083 MilitaryZipCode
	**/
    get ThirtyFourThousandAndEightyThree(): IMilitaryZipCode {
        return this.FromId(447);
    }
    /**
		Returns 34085 MilitaryZipCode
	**/
    get ThirtyFourThousandAndEightyFive(): IMilitaryZipCode {
        return this.FromId(448);
    }
    /**
		Returns 34086 MilitaryZipCode
	**/
    get ThirtyFourThousandAndEightySix(): IMilitaryZipCode {
        return this.FromId(449);
    }
    /**
		Returns 34087 MilitaryZipCode
	**/
    get ThirtyFourThousandAndEightySeven(): IMilitaryZipCode {
        return this.FromId(450);
    }
    /**
		Returns 34088 MilitaryZipCode
	**/
    get ThirtyFourThousandAndEightyEight(): IMilitaryZipCode {
        return this.FromId(451);
    }
    /**
		Returns 34090 MilitaryZipCode
	**/
    get ThirtyFourThousandAndNinety(): IMilitaryZipCode {
        return this.FromId(452);
    }
    /**
		Returns 34091 MilitaryZipCode
	**/
    get ThirtyFourThousandAndNinetyOne(): IMilitaryZipCode {
        return this.FromId(453);
    }
    /**
		Returns 34092 MilitaryZipCode
	**/
    get ThirtyFourThousandAndNinetyTwo(): IMilitaryZipCode {
        return this.FromId(454);
    }
    /**
		Returns 34093 MilitaryZipCode
	**/
    get ThirtyFourThousandAndNinetyThree(): IMilitaryZipCode {
        return this.FromId(455);
    }
    /**
		Returns 34095 MilitaryZipCode
	**/
    get ThirtyFourThousandAndNinetyFive(): IMilitaryZipCode {
        return this.FromId(456);
    }
    /**
		Returns 34097 MilitaryZipCode
	**/
    get ThirtyFourThousandAndNinetySeven(): IMilitaryZipCode {
        return this.FromId(457);
    }
    /**
		Returns 34099 MilitaryZipCode
	**/
    get ThirtyFourThousandAndNinetyNine(): IMilitaryZipCode {
        return this.FromId(458);
    }
    /**
		Returns 96202 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndTwo(): IMilitaryZipCode {
        return this.FromId(459);
    }
    /**
		Returns 96204 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndFour(): IMilitaryZipCode {
        return this.FromId(460);
    }
    /**
		Returns 96205 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndFive(): IMilitaryZipCode {
        return this.FromId(461);
    }
    /**
		Returns 96206 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndSix(): IMilitaryZipCode {
        return this.FromId(462);
    }
    /**
		Returns 96207 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndSeven(): IMilitaryZipCode {
        return this.FromId(463);
    }
    /**
		Returns 96208 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndEight(): IMilitaryZipCode {
        return this.FromId(464);
    }
    /**
		Returns 96212 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndTwelve(): IMilitaryZipCode {
        return this.FromId(465);
    }
    /**
		Returns 96213 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndThirteen(): IMilitaryZipCode {
        return this.FromId(466);
    }
    /**
		Returns 96214 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndFourteen(): IMilitaryZipCode {
        return this.FromId(467);
    }
    /**
		Returns 96218 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndEighteen(): IMilitaryZipCode {
        return this.FromId(468);
    }
    /**
		Returns 96224 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndTwentyFour(): IMilitaryZipCode {
        return this.FromId(469);
    }
    /**
		Returns 96230 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndThirty(): IMilitaryZipCode {
        return this.FromId(470);
    }
    /**
		Returns 96239 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndThirtyNine(): IMilitaryZipCode {
        return this.FromId(471);
    }
    /**
		Returns 96248 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndFortyEight(): IMilitaryZipCode {
        return this.FromId(472);
    }
    /**
		Returns 96251 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndFiftyOne(): IMilitaryZipCode {
        return this.FromId(473);
    }
    /**
		Returns 96257 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndFiftySeven(): IMilitaryZipCode {
        return this.FromId(474);
    }
    /**
		Returns 96258 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndFiftyEight(): IMilitaryZipCode {
        return this.FromId(475);
    }
    /**
		Returns 96259 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndFiftyNine(): IMilitaryZipCode {
        return this.FromId(476);
    }
    /**
		Returns 96260 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndSixty(): IMilitaryZipCode {
        return this.FromId(477);
    }
    /**
		Returns 96264 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndSixtyFour(): IMilitaryZipCode {
        return this.FromId(478);
    }
    /**
		Returns 96266 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndSixtySix(): IMilitaryZipCode {
        return this.FromId(479);
    }
    /**
		Returns 96271 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndSeventyOne(): IMilitaryZipCode {
        return this.FromId(480);
    }
    /**
		Returns 96274 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndSeventyFour(): IMilitaryZipCode {
        return this.FromId(481);
    }
    /**
		Returns 96275 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndSeventyFive(): IMilitaryZipCode {
        return this.FromId(482);
    }
    /**
		Returns 96278 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndSeventyEight(): IMilitaryZipCode {
        return this.FromId(483);
    }
    /**
		Returns 96286 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndEightySix(): IMilitaryZipCode {
        return this.FromId(484);
    }
    /**
		Returns 96293 MilitaryZipCode
	**/
    get NinetySixThousandTwoHundredAndNinetyThree(): IMilitaryZipCode {
        return this.FromId(485);
    }
    /**
		Returns 96301 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndOne(): IMilitaryZipCode {
        return this.FromId(486);
    }
    /**
		Returns 96303 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndThree(): IMilitaryZipCode {
        return this.FromId(487);
    }
    /**
		Returns 96305 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndFive(): IMilitaryZipCode {
        return this.FromId(488);
    }
    /**
		Returns 96306 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndSix(): IMilitaryZipCode {
        return this.FromId(489);
    }
    /**
		Returns 96311 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndEleven(): IMilitaryZipCode {
        return this.FromId(490);
    }
    /**
		Returns 96313 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndThirteen(): IMilitaryZipCode {
        return this.FromId(491);
    }
    /**
		Returns 96319 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndNineteen(): IMilitaryZipCode {
        return this.FromId(492);
    }
    /**
		Returns 96321 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndTwentyOne(): IMilitaryZipCode {
        return this.FromId(493);
    }
    /**
		Returns 96322 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndTwentyTwo(): IMilitaryZipCode {
        return this.FromId(494);
    }
    /**
		Returns 96324 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndTwentyFour(): IMilitaryZipCode {
        return this.FromId(495);
    }
    /**
		Returns 96326 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndTwentySix(): IMilitaryZipCode {
        return this.FromId(496);
    }
    /**
		Returns 96328 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndTwentyEight(): IMilitaryZipCode {
        return this.FromId(497);
    }
    /**
		Returns 96331 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndThirtyOne(): IMilitaryZipCode {
        return this.FromId(498);
    }
    /**
		Returns 96334 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndThirtyFour(): IMilitaryZipCode {
        return this.FromId(499);
    }
    /**
		Returns 96335 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndThirtyFive(): IMilitaryZipCode {
        return this.FromId(500);
    }
    /**
		Returns 96336 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndThirtySix(): IMilitaryZipCode {
        return this.FromId(501);
    }
    /**
		Returns 96337 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndThirtySeven(): IMilitaryZipCode {
        return this.FromId(502);
    }
    /**
		Returns 96338 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndThirtyEight(): IMilitaryZipCode {
        return this.FromId(503);
    }
    /**
		Returns 96343 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndFortyThree(): IMilitaryZipCode {
        return this.FromId(504);
    }
    /**
		Returns 96347 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndFortySeven(): IMilitaryZipCode {
        return this.FromId(505);
    }
    /**
		Returns 96348 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndFortyEight(): IMilitaryZipCode {
        return this.FromId(506);
    }
    /**
		Returns 96349 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndFortyNine(): IMilitaryZipCode {
        return this.FromId(507);
    }
    /**
		Returns 96350 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndFifty(): IMilitaryZipCode {
        return this.FromId(508);
    }
    /**
		Returns 96351 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndFiftyOne(): IMilitaryZipCode {
        return this.FromId(509);
    }
    /**
		Returns 96358 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndFiftyEight(): IMilitaryZipCode {
        return this.FromId(510);
    }
    /**
		Returns 96362 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndSixtyTwo(): IMilitaryZipCode {
        return this.FromId(511);
    }
    /**
		Returns 96364 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndSixtyFour(): IMilitaryZipCode {
        return this.FromId(512);
    }
    /**
		Returns 96366 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndSixtySix(): IMilitaryZipCode {
        return this.FromId(513);
    }
    /**
		Returns 96367 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndSixtySeven(): IMilitaryZipCode {
        return this.FromId(514);
    }
    /**
		Returns 96368 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndSixtyEight(): IMilitaryZipCode {
        return this.FromId(515);
    }
    /**
		Returns 96369 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndSixtyNine(): IMilitaryZipCode {
        return this.FromId(516);
    }
    /**
		Returns 96370 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndSeventy(): IMilitaryZipCode {
        return this.FromId(517);
    }
    /**
		Returns 96372 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndSeventyTwo(): IMilitaryZipCode {
        return this.FromId(518);
    }
    /**
		Returns 96373 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndSeventyThree(): IMilitaryZipCode {
        return this.FromId(519);
    }
    /**
		Returns 96374 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndSeventyFour(): IMilitaryZipCode {
        return this.FromId(520);
    }
    /**
		Returns 96375 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndSeventyFive(): IMilitaryZipCode {
        return this.FromId(521);
    }
    /**
		Returns 96376 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndSeventySix(): IMilitaryZipCode {
        return this.FromId(522);
    }
    /**
		Returns 96377 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndSeventySeven(): IMilitaryZipCode {
        return this.FromId(523);
    }
    /**
		Returns 96379 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndSeventyNine(): IMilitaryZipCode {
        return this.FromId(524);
    }
    /**
		Returns 96384 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndEightyFour(): IMilitaryZipCode {
        return this.FromId(525);
    }
    /**
		Returns 96386 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndEightySix(): IMilitaryZipCode {
        return this.FromId(526);
    }
    /**
		Returns 96408 MilitaryZipCode
	**/
    get NinetySixThousandFourHundredAndEight(): IMilitaryZipCode {
        return this.FromId(527);
    }
    /**
		Returns 96427 MilitaryZipCode
	**/
    get NinetySixThousandFourHundredAndTwentySeven(): IMilitaryZipCode {
        return this.FromId(528);
    }
    /**
		Returns 96432 MilitaryZipCode
	**/
    get NinetySixThousandFourHundredAndThirtyTwo(): IMilitaryZipCode {
        return this.FromId(529);
    }
    /**
		Returns 96450 MilitaryZipCode
	**/
    get NinetySixThousandFourHundredAndFifty(): IMilitaryZipCode {
        return this.FromId(530);
    }
    /**
		Returns 96455 MilitaryZipCode
	**/
    get NinetySixThousandFourHundredAndFiftyFive(): IMilitaryZipCode {
        return this.FromId(531);
    }
    /**
		Returns 96460 MilitaryZipCode
	**/
    get NinetySixThousandFourHundredAndSixty(): IMilitaryZipCode {
        return this.FromId(532);
    }
    /**
		Returns 96461 MilitaryZipCode
	**/
    get NinetySixThousandFourHundredAndSixtyOne(): IMilitaryZipCode {
        return this.FromId(533);
    }
    /**
		Returns 96464 MilitaryZipCode
	**/
    get NinetySixThousandFourHundredAndSixtyFour(): IMilitaryZipCode {
        return this.FromId(534);
    }
    /**
		Returns 96505 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndFive(): IMilitaryZipCode {
        return this.FromId(535);
    }
    /**
		Returns 96507 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndSeven(): IMilitaryZipCode {
        return this.FromId(536);
    }
    /**
		Returns 96508 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndEight(): IMilitaryZipCode {
        return this.FromId(537);
    }
    /**
		Returns 96510 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndTen(): IMilitaryZipCode {
        return this.FromId(538);
    }
    /**
		Returns 96512 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndTwelve(): IMilitaryZipCode {
        return this.FromId(539);
    }
    /**
		Returns 96515 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndFifteen(): IMilitaryZipCode {
        return this.FromId(540);
    }
    /**
		Returns 96519 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndNineteen(): IMilitaryZipCode {
        return this.FromId(541);
    }
    /**
		Returns 96520 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndTwenty(): IMilitaryZipCode {
        return this.FromId(542);
    }
    /**
		Returns 96521 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndTwentyOne(): IMilitaryZipCode {
        return this.FromId(543);
    }
    /**
		Returns 96524 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndTwentyFour(): IMilitaryZipCode {
        return this.FromId(544);
    }
    /**
		Returns 96528 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndTwentyEight(): IMilitaryZipCode {
        return this.FromId(545);
    }
    /**
		Returns 96533 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndThirtyThree(): IMilitaryZipCode {
        return this.FromId(546);
    }
    /**
		Returns 96534 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndThirtyFour(): IMilitaryZipCode {
        return this.FromId(547);
    }
    /**
		Returns 96535 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndThirtyFive(): IMilitaryZipCode {
        return this.FromId(548);
    }
    /**
		Returns 96538 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndThirtyEight(): IMilitaryZipCode {
        return this.FromId(549);
    }
    /**
		Returns 96539 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndThirtyNine(): IMilitaryZipCode {
        return this.FromId(550);
    }
    /**
		Returns 96540 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndForty(): IMilitaryZipCode {
        return this.FromId(551);
    }
    /**
		Returns 96542 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndFortyTwo(): IMilitaryZipCode {
        return this.FromId(552);
    }
    /**
		Returns 96543 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndFortyThree(): IMilitaryZipCode {
        return this.FromId(553);
    }
    /**
		Returns 96546 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndFortySix(): IMilitaryZipCode {
        return this.FromId(554);
    }
    /**
		Returns 96548 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndFortyEight(): IMilitaryZipCode {
        return this.FromId(555);
    }
    /**
		Returns 96549 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndFortyNine(): IMilitaryZipCode {
        return this.FromId(556);
    }
    /**
		Returns 96551 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndFiftyOne(): IMilitaryZipCode {
        return this.FromId(557);
    }
    /**
		Returns 96552 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndFiftyTwo(): IMilitaryZipCode {
        return this.FromId(558);
    }
    /**
		Returns 96553 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndFiftyThree(): IMilitaryZipCode {
        return this.FromId(559);
    }
    /**
		Returns 96554 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndFiftyFour(): IMilitaryZipCode {
        return this.FromId(560);
    }
    /**
		Returns 96555 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndFiftyFive(): IMilitaryZipCode {
        return this.FromId(561);
    }
    /**
		Returns 96557 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndFiftySeven(): IMilitaryZipCode {
        return this.FromId(562);
    }
    /**
		Returns 96558 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndFiftyEight(): IMilitaryZipCode {
        return this.FromId(563);
    }
    /**
		Returns 96595 MilitaryZipCode
	**/
    get NinetySixThousandFiveHundredAndNinetyFive(): IMilitaryZipCode {
        return this.FromId(564);
    }
    /**
		Returns 96601 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndOne(): IMilitaryZipCode {
        return this.FromId(565);
    }
    /**
		Returns 96602 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndTwo(): IMilitaryZipCode {
        return this.FromId(566);
    }
    /**
		Returns 96603 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndThree(): IMilitaryZipCode {
        return this.FromId(567);
    }
    /**
		Returns 96604 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndFour(): IMilitaryZipCode {
        return this.FromId(568);
    }
    /**
		Returns 96606 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndSix(): IMilitaryZipCode {
        return this.FromId(569);
    }
    /**
		Returns 96607 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndSeven(): IMilitaryZipCode {
        return this.FromId(570);
    }
    /**
		Returns 96608 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndEight(): IMilitaryZipCode {
        return this.FromId(571);
    }
    /**
		Returns 96609 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndNine(): IMilitaryZipCode {
        return this.FromId(572);
    }
    /**
		Returns 96610 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndTen(): IMilitaryZipCode {
        return this.FromId(573);
    }
    /**
		Returns 96612 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndTwelve(): IMilitaryZipCode {
        return this.FromId(574);
    }
    /**
		Returns 96614 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndFourteen(): IMilitaryZipCode {
        return this.FromId(575);
    }
    /**
		Returns 96615 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndFifteen(): IMilitaryZipCode {
        return this.FromId(576);
    }
    /**
		Returns 96616 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndSixteen(): IMilitaryZipCode {
        return this.FromId(577);
    }
    /**
		Returns 96617 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndSeventeen(): IMilitaryZipCode {
        return this.FromId(578);
    }
    /**
		Returns 96618 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndEighteen(): IMilitaryZipCode {
        return this.FromId(579);
    }
    /**
		Returns 96620 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndTwenty(): IMilitaryZipCode {
        return this.FromId(580);
    }
    /**
		Returns 96621 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndTwentyOne(): IMilitaryZipCode {
        return this.FromId(581);
    }
    /**
		Returns 96622 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndTwentyTwo(): IMilitaryZipCode {
        return this.FromId(582);
    }
    /**
		Returns 96623 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndTwentyThree(): IMilitaryZipCode {
        return this.FromId(583);
    }
    /**
		Returns 96624 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndTwentyFour(): IMilitaryZipCode {
        return this.FromId(584);
    }
    /**
		Returns 96626 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndTwentySix(): IMilitaryZipCode {
        return this.FromId(585);
    }
    /**
		Returns 96627 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndTwentySeven(): IMilitaryZipCode {
        return this.FromId(586);
    }
    /**
		Returns 96628 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndTwentyEight(): IMilitaryZipCode {
        return this.FromId(587);
    }
    /**
		Returns 96629 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndTwentyNine(): IMilitaryZipCode {
        return this.FromId(588);
    }
    /**
		Returns 96630 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndThirty(): IMilitaryZipCode {
        return this.FromId(589);
    }
    /**
		Returns 96631 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndThirtyOne(): IMilitaryZipCode {
        return this.FromId(590);
    }
    /**
		Returns 96632 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndThirtyTwo(): IMilitaryZipCode {
        return this.FromId(591);
    }
    /**
		Returns 96633 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndThirtyThree(): IMilitaryZipCode {
        return this.FromId(592);
    }
    /**
		Returns 96634 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndThirtyFour(): IMilitaryZipCode {
        return this.FromId(593);
    }
    /**
		Returns 96635 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndThirtyFive(): IMilitaryZipCode {
        return this.FromId(594);
    }
    /**
		Returns 96636 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndThirtySix(): IMilitaryZipCode {
        return this.FromId(595);
    }
    /**
		Returns 96637 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndThirtySeven(): IMilitaryZipCode {
        return this.FromId(596);
    }
    /**
		Returns 96639 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndThirtyNine(): IMilitaryZipCode {
        return this.FromId(597);
    }
    /**
		Returns 96641 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndFortyOne(): IMilitaryZipCode {
        return this.FromId(598);
    }
    /**
		Returns 96642 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndFortyTwo(): IMilitaryZipCode {
        return this.FromId(599);
    }
    /**
		Returns 96643 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndFortyThree(): IMilitaryZipCode {
        return this.FromId(600);
    }
    /**
		Returns 96644 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndFortyFour(): IMilitaryZipCode {
        return this.FromId(601);
    }
    /**
		Returns 96646 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndFortySix(): IMilitaryZipCode {
        return this.FromId(602);
    }
    /**
		Returns 96647 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndFortySeven(): IMilitaryZipCode {
        return this.FromId(603);
    }
    /**
		Returns 96648 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndFortyEight(): IMilitaryZipCode {
        return this.FromId(604);
    }
    /**
		Returns 96649 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndFortyNine(): IMilitaryZipCode {
        return this.FromId(605);
    }
    /**
		Returns 96651 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndFiftyOne(): IMilitaryZipCode {
        return this.FromId(606);
    }
    /**
		Returns 96654 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndFiftyFour(): IMilitaryZipCode {
        return this.FromId(607);
    }
    /**
		Returns 96656 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndFiftySix(): IMilitaryZipCode {
        return this.FromId(608);
    }
    /**
		Returns 96657 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndFiftySeven(): IMilitaryZipCode {
        return this.FromId(609);
    }
    /**
		Returns 96660 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndSixty(): IMilitaryZipCode {
        return this.FromId(610);
    }
    /**
		Returns 96661 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndSixtyOne(): IMilitaryZipCode {
        return this.FromId(611);
    }
    /**
		Returns 96662 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndSixtyTwo(): IMilitaryZipCode {
        return this.FromId(612);
    }
    /**
		Returns 96663 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndSixtyThree(): IMilitaryZipCode {
        return this.FromId(613);
    }
    /**
		Returns 96664 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndSixtyFour(): IMilitaryZipCode {
        return this.FromId(614);
    }
    /**
		Returns 96665 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndSixtyFive(): IMilitaryZipCode {
        return this.FromId(615);
    }
    /**
		Returns 96666 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndSixtySix(): IMilitaryZipCode {
        return this.FromId(616);
    }
    /**
		Returns 96667 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndSixtySeven(): IMilitaryZipCode {
        return this.FromId(617);
    }
    /**
		Returns 96669 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndSixtyNine(): IMilitaryZipCode {
        return this.FromId(618);
    }
    /**
		Returns 96670 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndSeventy(): IMilitaryZipCode {
        return this.FromId(619);
    }
    /**
		Returns 96671 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndSeventyOne(): IMilitaryZipCode {
        return this.FromId(620);
    }
    /**
		Returns 96672 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndSeventyTwo(): IMilitaryZipCode {
        return this.FromId(621);
    }
    /**
		Returns 96673 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndSeventyThree(): IMilitaryZipCode {
        return this.FromId(622);
    }
    /**
		Returns 96674 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndSeventyFour(): IMilitaryZipCode {
        return this.FromId(623);
    }
    /**
		Returns 96675 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndSeventyFive(): IMilitaryZipCode {
        return this.FromId(624);
    }
    /**
		Returns 96677 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndSeventySeven(): IMilitaryZipCode {
        return this.FromId(625);
    }
    /**
		Returns 96678 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndSeventyEight(): IMilitaryZipCode {
        return this.FromId(626);
    }
    /**
		Returns 96679 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndSeventyNine(): IMilitaryZipCode {
        return this.FromId(627);
    }
    /**
		Returns 96680 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndEighty(): IMilitaryZipCode {
        return this.FromId(628);
    }
    /**
		Returns 96682 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndEightyTwo(): IMilitaryZipCode {
        return this.FromId(629);
    }
    /**
		Returns 96683 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndEightyThree(): IMilitaryZipCode {
        return this.FromId(630);
    }
    /**
		Returns 96685 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndEightyFive(): IMilitaryZipCode {
        return this.FromId(631);
    }
    /**
		Returns 96688 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndEightyEight(): IMilitaryZipCode {
        return this.FromId(632);
    }
    /**
		Returns 96697 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndNinetySeven(): IMilitaryZipCode {
        return this.FromId(633);
    }
    /**
		Returns 96698 MilitaryZipCode
	**/
    get NinetySixThousandSixHundredAndNinetyEight(): IMilitaryZipCode {
        return this.FromId(634);
    }
    /**
		Returns 98772 MilitaryZipCode
	**/
    get NinetyEightThousandSevenHundredAndSeventyTwo(): IMilitaryZipCode {
        return this.FromId(635);
    }
    /**
		Returns 98775 MilitaryZipCode
	**/
    get NinetyEightThousandSevenHundredAndSeventyFive(): IMilitaryZipCode {
        return this.FromId(636);
    }
    /**
		Returns 85309 MilitaryZipCode
	**/
    get EightyFiveThousandThreeHundredAndNine(): IMilitaryZipCode {
        return this.FromId(637);
    }
    /**
		Returns 85708 MilitaryZipCode
	**/
    get EightyFiveThousandSevenHundredAndEight(): IMilitaryZipCode {
        return this.FromId(638);
    }
    /**
		Returns 96380 MilitaryZipCode
	**/
    get NinetySixThousandThreeHundredAndEighty(): IMilitaryZipCode {
        return this.FromId(639);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09001', city: '', active: true });
        this._dictionary.add('2', { id: 2, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09002', city: '', active: true });
        this._dictionary.add('3', { id: 3, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09008', city: '', active: true });
        this._dictionary.add('4', { id: 4, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09009', city: '', active: true });
        this._dictionary.add('5', { id: 5, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09011', city: '', active: true });
        this._dictionary.add('6', { id: 6, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09012', city: '', active: true });
        this._dictionary.add('7', { id: 7, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09014', city: '', active: true });
        this._dictionary.add('8', { id: 8, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09017', city: '', active: true });
        this._dictionary.add('9', { id: 9, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09020', city: '', active: true });
        this._dictionary.add('10', { id: 10, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09021', city: '', active: true });
        this._dictionary.add('11', { id: 11, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09023', city: '', active: true });
        this._dictionary.add('12', { id: 12, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09026', city: '', active: true });
        this._dictionary.add('13', { id: 13, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09028', city: '', active: true });
        this._dictionary.add('14', { id: 14, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09031', city: '', active: true });
        this._dictionary.add('15', { id: 15, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09033', city: '', active: true });
        this._dictionary.add('16', { id: 16, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09034', city: '', active: true });
        this._dictionary.add('17', { id: 17, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09035', city: '', active: true });
        this._dictionary.add('18', { id: 18, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09036', city: '', active: true });
        this._dictionary.add('19', { id: 19, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09038', city: '', active: true });
        this._dictionary.add('20', { id: 20, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09039', city: '', active: true });
        this._dictionary.add('21', { id: 21, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09042', city: '', active: true });
        this._dictionary.add('22', { id: 22, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09045', city: '', active: true });
        this._dictionary.add('23', { id: 23, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09046', city: '', active: true });
        this._dictionary.add('24', { id: 24, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09047', city: '', active: true });
        this._dictionary.add('25', { id: 25, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09049', city: '', active: true });
        this._dictionary.add('26', { id: 26, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09050', city: '', active: true });
        this._dictionary.add('27', { id: 27, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09052', city: '', active: true });
        this._dictionary.add('28', { id: 28, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09053', city: '', active: true });
        this._dictionary.add('29', { id: 29, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09054', city: '', active: true });
        this._dictionary.add('30', { id: 30, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09055', city: '', active: true });
        this._dictionary.add('31', { id: 31, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09056', city: '', active: true });
        this._dictionary.add('32', { id: 32, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09057', city: '', active: true });
        this._dictionary.add('33', { id: 33, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09058', city: '', active: true });
        this._dictionary.add('34', { id: 34, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09059', city: '', active: true });
        this._dictionary.add('35', { id: 35, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09061', city: '', active: true });
        this._dictionary.add('36', { id: 36, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09063', city: '', active: true });
        this._dictionary.add('37', { id: 37, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09065', city: '', active: true });
        this._dictionary.add('38', { id: 38, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09066', city: '', active: true });
        this._dictionary.add('39', { id: 39, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09067', city: '', active: true });
        this._dictionary.add('40', { id: 40, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09069', city: '', active: true });
        this._dictionary.add('41', { id: 41, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09070', city: '', active: true });
        this._dictionary.add('42', { id: 42, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09072', city: '', active: true });
        this._dictionary.add('43', { id: 43, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09074', city: '', active: true });
        this._dictionary.add('44', { id: 44, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09075', city: '', active: true });
        this._dictionary.add('45', { id: 45, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09076', city: '', active: true });
        this._dictionary.add('46', { id: 46, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09077', city: '', active: true });
        this._dictionary.add('47', { id: 47, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09079', city: '', active: true });
        this._dictionary.add('48', { id: 48, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09080', city: '', active: true });
        this._dictionary.add('49', { id: 49, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09081', city: '', active: true });
        this._dictionary.add('50', { id: 50, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09083', city: '', active: true });
        this._dictionary.add('51', { id: 51, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09084', city: '', active: true });
        this._dictionary.add('52', { id: 52, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09086', city: '', active: true });
        this._dictionary.add('53', { id: 53, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09088', city: '', active: true });
        this._dictionary.add('54', { id: 54, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09090', city: '', active: true });
        this._dictionary.add('55', { id: 55, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09091', city: '', active: true });
        this._dictionary.add('56', { id: 56, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09092', city: '', active: true });
        this._dictionary.add('57', { id: 57, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09093', city: '', active: true });
        this._dictionary.add('58', { id: 58, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09094', city: '', active: true });
        this._dictionary.add('59', { id: 59, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09096', city: '', active: true });
        this._dictionary.add('60', { id: 60, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09097', city: '', active: true });
        this._dictionary.add('61', { id: 61, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09098', city: '', active: true });
        this._dictionary.add('62', { id: 62, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09099', city: '', active: true });
        this._dictionary.add('63', { id: 63, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09102', city: '', active: true });
        this._dictionary.add('64', { id: 64, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09103', city: '', active: true });
        this._dictionary.add('65', { id: 65, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09104', city: '', active: true });
        this._dictionary.add('66', { id: 66, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09105', city: '', active: true });
        this._dictionary.add('67', { id: 67, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09107', city: '', active: true });
        this._dictionary.add('68', { id: 68, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09108', city: '', active: true });
        this._dictionary.add('69', { id: 69, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09109', city: '', active: true });
        this._dictionary.add('70', { id: 70, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09110', city: '', active: true });
        this._dictionary.add('71', { id: 71, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09111', city: '', active: true });
        this._dictionary.add('72', { id: 72, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09112', city: '', active: true });
        this._dictionary.add('73', { id: 73, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09114', city: '', active: true });
        this._dictionary.add('74', { id: 74, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09121', city: '', active: true });
        this._dictionary.add('75', { id: 75, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09123', city: '', active: true });
        this._dictionary.add('76', { id: 76, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09125', city: '', active: true });
        this._dictionary.add('77', { id: 77, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09127', city: '', active: true });
        this._dictionary.add('78', { id: 78, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09128', city: '', active: true });
        this._dictionary.add('79', { id: 79, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09130', city: '', active: true });
        this._dictionary.add('80', { id: 80, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09131', city: '', active: true });
        this._dictionary.add('81', { id: 81, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09132', city: '', active: true });
        this._dictionary.add('82', { id: 82, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09133', city: '', active: true });
        this._dictionary.add('83', { id: 83, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09137', city: '', active: true });
        this._dictionary.add('84', { id: 84, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09139', city: '', active: true });
        this._dictionary.add('85', { id: 85, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09140', city: '', active: true });
        this._dictionary.add('86', { id: 86, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09141', city: '', active: true });
        this._dictionary.add('87', { id: 87, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09142', city: '', active: true });
        this._dictionary.add('88', { id: 88, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09144', city: '', active: true });
        this._dictionary.add('89', { id: 89, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09146', city: '', active: true });
        this._dictionary.add('90', { id: 90, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09150', city: '', active: true });
        this._dictionary.add('91', { id: 91, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09154', city: '', active: true });
        this._dictionary.add('92', { id: 92, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09157', city: '', active: true });
        this._dictionary.add('93', { id: 93, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09159', city: '', active: true });
        this._dictionary.add('94', { id: 94, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09160', city: '', active: true });
        this._dictionary.add('95', { id: 95, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09162', city: '', active: true });
        this._dictionary.add('96', { id: 96, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09164', city: '', active: true });
        this._dictionary.add('97', { id: 97, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09165', city: '', active: true });
        this._dictionary.add('98', { id: 98, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09166', city: '', active: true });
        this._dictionary.add('99', { id: 99, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09169', city: '', active: true });
        this._dictionary.add('100', { id: 100, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09172', city: '', active: true });
        this._dictionary.add('101', { id: 101, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09173', city: '', active: true });
        this._dictionary.add('102', { id: 102, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09175', city: '', active: true });
        this._dictionary.add('103', { id: 103, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09176', city: '', active: true });
        this._dictionary.add('104', { id: 104, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09177', city: '', active: true });
        this._dictionary.add('105', { id: 105, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09178', city: '', active: true });
        this._dictionary.add('106', { id: 106, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09179', city: '', active: true });
        this._dictionary.add('107', { id: 107, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09180', city: '', active: true });
        this._dictionary.add('108', { id: 108, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09182', city: '', active: true });
        this._dictionary.add('109', { id: 109, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09185', city: '', active: true });
        this._dictionary.add('110', { id: 110, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09188', city: '', active: true });
        this._dictionary.add('111', { id: 111, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09189', city: '', active: true });
        this._dictionary.add('112', { id: 112, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09192', city: '', active: true });
        this._dictionary.add('113', { id: 113, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09193', city: '', active: true });
        this._dictionary.add('114', { id: 114, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09194', city: '', active: true });
        this._dictionary.add('115', { id: 115, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09205', city: '', active: true });
        this._dictionary.add('116', { id: 116, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09206', city: '', active: true });
        this._dictionary.add('117', { id: 117, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09209', city: '', active: true });
        this._dictionary.add('118', { id: 118, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09210', city: '', active: true });
        this._dictionary.add('119', { id: 119, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09211', city: '', active: true });
        this._dictionary.add('120', { id: 120, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09213', city: '', active: true });
        this._dictionary.add('121', { id: 121, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09214', city: '', active: true });
        this._dictionary.add('122', { id: 122, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09220', city: '', active: true });
        this._dictionary.add('123', { id: 123, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09221', city: '', active: true });
        this._dictionary.add('124', { id: 124, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09222', city: '', active: true });
        this._dictionary.add('125', { id: 125, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09223', city: '', active: true });
        this._dictionary.add('126', { id: 126, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09224', city: '', active: true });
        this._dictionary.add('127', { id: 127, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09225', city: '', active: true });
        this._dictionary.add('128', { id: 128, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09226', city: '', active: true });
        this._dictionary.add('129', { id: 129, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09227', city: '', active: true });
        this._dictionary.add('130', { id: 130, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09235', city: '', active: true });
        this._dictionary.add('131', { id: 131, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09237', city: '', active: true });
        this._dictionary.add('132', { id: 132, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09238', city: '', active: true });
        this._dictionary.add('133', { id: 133, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09240', city: '', active: true });
        this._dictionary.add('134', { id: 134, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09242', city: '', active: true });
        this._dictionary.add('135', { id: 135, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09244', city: '', active: true });
        this._dictionary.add('136', { id: 136, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09245', city: '', active: true });
        this._dictionary.add('137', { id: 137, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09250', city: '', active: true });
        this._dictionary.add('138', { id: 138, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09252', city: '', active: true });
        this._dictionary.add('139', { id: 139, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09253', city: '', active: true });
        this._dictionary.add('140', { id: 140, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09254', city: '', active: true });
        this._dictionary.add('141', { id: 141, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09255', city: '', active: true });
        this._dictionary.add('142', { id: 142, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09262', city: '', active: true });
        this._dictionary.add('143', { id: 143, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09263', city: '', active: true });
        this._dictionary.add('144', { id: 144, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09264', city: '', active: true });
        this._dictionary.add('145', { id: 145, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09265', city: '', active: true });
        this._dictionary.add('146', { id: 146, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09266', city: '', active: true });
        this._dictionary.add('147', { id: 147, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09267', city: '', active: true });
        this._dictionary.add('148', { id: 148, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09279', city: '', active: true });
        this._dictionary.add('149', { id: 149, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09281', city: '', active: true });
        this._dictionary.add('150', { id: 150, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09283', city: '', active: true });
        this._dictionary.add('151', { id: 151, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09285', city: '', active: true });
        this._dictionary.add('152', { id: 152, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09286', city: '', active: true });
        this._dictionary.add('153', { id: 153, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09289', city: '', active: true });
        this._dictionary.add('154', { id: 154, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09291', city: '', active: true });
        this._dictionary.add('155', { id: 155, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09292', city: '', active: true });
        this._dictionary.add('156', { id: 156, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09293', city: '', active: true });
        this._dictionary.add('157', { id: 157, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09294', city: '', active: true });
        this._dictionary.add('158', { id: 158, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09295', city: '', active: true });
        this._dictionary.add('159', { id: 159, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09305', city: '', active: true });
        this._dictionary.add('160', { id: 160, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09306', city: '', active: true });
        this._dictionary.add('161', { id: 161, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09308', city: '', active: true });
        this._dictionary.add('162', { id: 162, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09309', city: '', active: true });
        this._dictionary.add('163', { id: 163, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09311', city: '', active: true });
        this._dictionary.add('164', { id: 164, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09312', city: '', active: true });
        this._dictionary.add('165', { id: 165, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09315', city: '', active: true });
        this._dictionary.add('166', { id: 166, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09316', city: '', active: true });
        this._dictionary.add('167', { id: 167, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09317', city: '', active: true });
        this._dictionary.add('168', { id: 168, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09320', city: '', active: true });
        this._dictionary.add('169', { id: 169, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09321', city: '', active: true });
        this._dictionary.add('170', { id: 170, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09322', city: '', active: true });
        this._dictionary.add('171', { id: 171, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09323', city: '', active: true });
        this._dictionary.add('172', { id: 172, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09324', city: '', active: true });
        this._dictionary.add('173', { id: 173, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09325', city: '', active: true });
        this._dictionary.add('174', { id: 174, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09326', city: '', active: true });
        this._dictionary.add('175', { id: 175, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09330', city: '', active: true });
        this._dictionary.add('176', { id: 176, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09331', city: '', active: true });
        this._dictionary.add('177', { id: 177, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09332', city: '', active: true });
        this._dictionary.add('178', { id: 178, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09333', city: '', active: true });
        this._dictionary.add('179', { id: 179, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09334', city: '', active: true });
        this._dictionary.add('180', { id: 180, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09335', city: '', active: true });
        this._dictionary.add('181', { id: 181, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09340', city: '', active: true });
        this._dictionary.add('182', { id: 182, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09342', city: '', active: true });
        this._dictionary.add('183', { id: 183, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09344', city: '', active: true });
        this._dictionary.add('184', { id: 184, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09347', city: '', active: true });
        this._dictionary.add('185', { id: 185, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09348', city: '', active: true });
        this._dictionary.add('186', { id: 186, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09351', city: '', active: true });
        this._dictionary.add('187', { id: 187, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09352', city: '', active: true });
        this._dictionary.add('188', { id: 188, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09353', city: '', active: true });
        this._dictionary.add('189', { id: 189, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09354', city: '', active: true });
        this._dictionary.add('190', { id: 190, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09355', city: '', active: true });
        this._dictionary.add('191', { id: 191, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09358', city: '', active: true });
        this._dictionary.add('192', { id: 192, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09360', city: '', active: true });
        this._dictionary.add('193', { id: 193, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09361', city: '', active: true });
        this._dictionary.add('194', { id: 194, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09366', city: '', active: true });
        this._dictionary.add('195', { id: 195, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09368', city: '', active: true });
        this._dictionary.add('196', { id: 196, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09375', city: '', active: true });
        this._dictionary.add('197', { id: 197, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09376', city: '', active: true });
        this._dictionary.add('198', { id: 198, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09378', city: '', active: true });
        this._dictionary.add('199', { id: 199, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09379', city: '', active: true });
        this._dictionary.add('200', { id: 200, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09384', city: '', active: true });
        this._dictionary.add('201', { id: 201, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09390', city: '', active: true });
        this._dictionary.add('202', { id: 202, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09391', city: '', active: true });
        this._dictionary.add('203', { id: 203, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09392', city: '', active: true });
        this._dictionary.add('204', { id: 204, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09393', city: '', active: true });
        this._dictionary.add('205', { id: 205, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09394', city: '', active: true });
        this._dictionary.add('206', { id: 206, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09396', city: '', active: true });
        this._dictionary.add('207', { id: 207, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09403', city: '', active: true });
        this._dictionary.add('208', { id: 208, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09405', city: '', active: true });
        this._dictionary.add('209', { id: 209, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09406', city: '', active: true });
        this._dictionary.add('210', { id: 210, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09407', city: '', active: true });
        this._dictionary.add('211', { id: 211, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09409', city: '', active: true });
        this._dictionary.add('212', { id: 212, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09411', city: '', active: true });
        this._dictionary.add('213', { id: 213, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09419', city: '', active: true });
        this._dictionary.add('214', { id: 214, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09420', city: '', active: true });
        this._dictionary.add('215', { id: 215, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09421', city: '', active: true });
        this._dictionary.add('216', { id: 216, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09447', city: '', active: true });
        this._dictionary.add('217', { id: 217, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09449', city: '', active: true });
        this._dictionary.add('218', { id: 218, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09451', city: '', active: true });
        this._dictionary.add('219', { id: 219, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09452', city: '', active: true });
        this._dictionary.add('220', { id: 220, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09454', city: '', active: true });
        this._dictionary.add('221', { id: 221, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09455', city: '', active: true });
        this._dictionary.add('222', { id: 222, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09456', city: '', active: true });
        this._dictionary.add('223', { id: 223, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09457', city: '', active: true });
        this._dictionary.add('224', { id: 224, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09458', city: '', active: true });
        this._dictionary.add('225', { id: 225, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09459', city: '', active: true });
        this._dictionary.add('226', { id: 226, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09464', city: '', active: true });
        this._dictionary.add('227', { id: 227, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09465', city: '', active: true });
        this._dictionary.add('228', { id: 228, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09466', city: '', active: true });
        this._dictionary.add('229', { id: 229, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09468', city: '', active: true });
        this._dictionary.add('230', { id: 230, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09469', city: '', active: true });
        this._dictionary.add('231', { id: 231, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09470', city: '', active: true });
        this._dictionary.add('232', { id: 232, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09494', city: '', active: true });
        this._dictionary.add('233', { id: 233, militaryCityPrefixTypeId: 2, jurisdictionId: 67, value: '09498', city: '', active: true });
        this._dictionary.add('234', { id: 234, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09499', city: '', active: true });
        this._dictionary.add('235', { id: 235, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09503', city: '', active: true });
        this._dictionary.add('236', { id: 236, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09507', city: '', active: true });
        this._dictionary.add('237', { id: 237, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09508', city: '', active: true });
        this._dictionary.add('238', { id: 238, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09509', city: '', active: true });
        this._dictionary.add('239', { id: 239, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09510', city: '', active: true });
        this._dictionary.add('240', { id: 240, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09512', city: '', active: true });
        this._dictionary.add('241', { id: 241, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09513', city: '', active: true });
        this._dictionary.add('242', { id: 242, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09517', city: '', active: true });
        this._dictionary.add('243', { id: 243, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09518', city: '', active: true });
        this._dictionary.add('244', { id: 244, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09519', city: '', active: true });
        this._dictionary.add('245', { id: 245, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09520', city: '', active: true });
        this._dictionary.add('246', { id: 246, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09521', city: '', active: true });
        this._dictionary.add('247', { id: 247, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09522', city: '', active: true });
        this._dictionary.add('248', { id: 248, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09523', city: '', active: true });
        this._dictionary.add('249', { id: 249, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09524', city: '', active: true });
        this._dictionary.add('250', { id: 250, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09527', city: '', active: true });
        this._dictionary.add('251', { id: 251, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09529', city: '', active: true });
        this._dictionary.add('252', { id: 252, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09531', city: '', active: true });
        this._dictionary.add('253', { id: 253, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09532', city: '', active: true });
        this._dictionary.add('254', { id: 254, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09533', city: '', active: true });
        this._dictionary.add('255', { id: 255, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09534', city: '', active: true });
        this._dictionary.add('256', { id: 256, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09536', city: '', active: true });
        this._dictionary.add('257', { id: 257, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09537', city: '', active: true });
        this._dictionary.add('258', { id: 258, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09538', city: '', active: true });
        this._dictionary.add('259', { id: 259, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09539', city: '', active: true });
        this._dictionary.add('260', { id: 260, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09540', city: '', active: true });
        this._dictionary.add('261', { id: 261, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09542', city: '', active: true });
        this._dictionary.add('262', { id: 262, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09543', city: '', active: true });
        this._dictionary.add('263', { id: 263, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09544', city: '', active: true });
        this._dictionary.add('264', { id: 264, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09545', city: '', active: true });
        this._dictionary.add('265', { id: 265, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09547', city: '', active: true });
        this._dictionary.add('266', { id: 266, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09548', city: '', active: true });
        this._dictionary.add('267', { id: 267, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09549', city: '', active: true });
        this._dictionary.add('268', { id: 268, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09550', city: '', active: true });
        this._dictionary.add('269', { id: 269, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09551', city: '', active: true });
        this._dictionary.add('270', { id: 270, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09552', city: '', active: true });
        this._dictionary.add('271', { id: 271, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09556', city: '', active: true });
        this._dictionary.add('272', { id: 272, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09557', city: '', active: true });
        this._dictionary.add('273', { id: 273, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09559', city: '', active: true });
        this._dictionary.add('274', { id: 274, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09560', city: '', active: true });
        this._dictionary.add('275', { id: 275, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09561', city: '', active: true });
        this._dictionary.add('276', { id: 276, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09564', city: '', active: true });
        this._dictionary.add('277', { id: 277, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09565', city: '', active: true });
        this._dictionary.add('278', { id: 278, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09566', city: '', active: true });
        this._dictionary.add('279', { id: 279, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09567', city: '', active: true });
        this._dictionary.add('280', { id: 280, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09568', city: '', active: true });
        this._dictionary.add('281', { id: 281, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09570', city: '', active: true });
        this._dictionary.add('282', { id: 282, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09571', city: '', active: true });
        this._dictionary.add('283', { id: 283, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09573', city: '', active: true });
        this._dictionary.add('284', { id: 284, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09576', city: '', active: true });
        this._dictionary.add('285', { id: 285, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09577', city: '', active: true });
        this._dictionary.add('286', { id: 286, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09578', city: '', active: true });
        this._dictionary.add('287', { id: 287, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09579', city: '', active: true });
        this._dictionary.add('288', { id: 288, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09582', city: '', active: true });
        this._dictionary.add('289', { id: 289, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09586', city: '', active: true });
        this._dictionary.add('290', { id: 290, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09587', city: '', active: true });
        this._dictionary.add('291', { id: 291, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09588', city: '', active: true });
        this._dictionary.add('292', { id: 292, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09589', city: '', active: true });
        this._dictionary.add('293', { id: 293, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09590', city: '', active: true });
        this._dictionary.add('294', { id: 294, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09591', city: '', active: true });
        this._dictionary.add('295', { id: 295, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09593', city: '', active: true });
        this._dictionary.add('296', { id: 296, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09594', city: '', active: true });
        this._dictionary.add('297', { id: 297, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09595', city: '', active: true });
        this._dictionary.add('298', { id: 298, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09597', city: '', active: true });
        this._dictionary.add('299', { id: 299, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09599', city: '', active: true });
        this._dictionary.add('300', { id: 300, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09601', city: '', active: true });
        this._dictionary.add('301', { id: 301, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09603', city: '', active: true });
        this._dictionary.add('302', { id: 302, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09605', city: '', active: true });
        this._dictionary.add('303', { id: 303, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09607', city: '', active: true });
        this._dictionary.add('304', { id: 304, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09608', city: '', active: true });
        this._dictionary.add('305', { id: 305, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09609', city: '', active: true });
        this._dictionary.add('306', { id: 306, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09610', city: '', active: true });
        this._dictionary.add('307', { id: 307, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09612', city: '', active: true });
        this._dictionary.add('308', { id: 308, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09613', city: '', active: true });
        this._dictionary.add('309', { id: 309, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09616', city: '', active: true });
        this._dictionary.add('310', { id: 310, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09617', city: '', active: true });
        this._dictionary.add('311', { id: 311, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09618', city: '', active: true });
        this._dictionary.add('312', { id: 312, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09619', city: '', active: true });
        this._dictionary.add('313', { id: 313, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09620', city: '', active: true });
        this._dictionary.add('314', { id: 314, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09621', city: '', active: true });
        this._dictionary.add('315', { id: 315, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09622', city: '', active: true });
        this._dictionary.add('316', { id: 316, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09623', city: '', active: true });
        this._dictionary.add('317', { id: 317, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09624', city: '', active: true });
        this._dictionary.add('318', { id: 318, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09625', city: '', active: true });
        this._dictionary.add('319', { id: 319, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09626', city: '', active: true });
        this._dictionary.add('320', { id: 320, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09627', city: '', active: true });
        this._dictionary.add('321', { id: 321, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09628', city: '', active: true });
        this._dictionary.add('322', { id: 322, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09630', city: '', active: true });
        this._dictionary.add('323', { id: 323, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09633', city: '', active: true });
        this._dictionary.add('324', { id: 324, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09636', city: '', active: true });
        this._dictionary.add('325', { id: 325, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09642', city: '', active: true });
        this._dictionary.add('326', { id: 326, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09643', city: '', active: true });
        this._dictionary.add('327', { id: 327, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09644', city: '', active: true });
        this._dictionary.add('328', { id: 328, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09645', city: '', active: true });
        this._dictionary.add('329', { id: 329, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09648', city: '', active: true });
        this._dictionary.add('330', { id: 330, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09649', city: '', active: true });
        this._dictionary.add('331', { id: 331, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09657', city: '', active: true });
        this._dictionary.add('332', { id: 332, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09667', city: '', active: true });
        this._dictionary.add('333', { id: 333, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09668', city: '', active: true });
        this._dictionary.add('334', { id: 334, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09669', city: '', active: true });
        this._dictionary.add('335', { id: 335, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09672', city: '', active: true });
        this._dictionary.add('336', { id: 336, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09673', city: '', active: true });
        this._dictionary.add('337', { id: 337, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09690', city: '', active: true });
        this._dictionary.add('338', { id: 338, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09692', city: '', active: true });
        this._dictionary.add('339', { id: 339, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09694', city: '', active: true });
        this._dictionary.add('340', { id: 340, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09696', city: '', active: true });
        this._dictionary.add('341', { id: 341, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09697', city: '', active: true });
        this._dictionary.add('342', { id: 342, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09701', city: '', active: true });
        this._dictionary.add('343', { id: 343, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09702', city: '', active: true });
        this._dictionary.add('344', { id: 344, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09703', city: '', active: true });
        this._dictionary.add('345', { id: 345, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09704', city: '', active: true });
        this._dictionary.add('346', { id: 346, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09705', city: '', active: true });
        this._dictionary.add('347', { id: 347, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09706', city: '', active: true });
        this._dictionary.add('348', { id: 348, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09707', city: '', active: true });
        this._dictionary.add('349', { id: 349, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09708', city: '', active: true });
        this._dictionary.add('350', { id: 350, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09710', city: '', active: true });
        this._dictionary.add('351', { id: 351, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09712', city: '', active: true });
        this._dictionary.add('352', { id: 352, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09714', city: '', active: true });
        this._dictionary.add('353', { id: 353, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09715', city: '', active: true });
        this._dictionary.add('354', { id: 354, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09717', city: '', active: true });
        this._dictionary.add('355', { id: 355, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09718', city: '', active: true });
        this._dictionary.add('356', { id: 356, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09719', city: '', active: true });
        this._dictionary.add('357', { id: 357, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09720', city: '', active: true });
        this._dictionary.add('358', { id: 358, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09721', city: '', active: true });
        this._dictionary.add('359', { id: 359, militaryCityPrefixTypeId: 2, jurisdictionId: 67, value: '09723', city: '', active: true });
        this._dictionary.add('360', { id: 360, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09724', city: '', active: true });
        this._dictionary.add('361', { id: 361, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09725', city: '', active: true });
        this._dictionary.add('362', { id: 362, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09728', city: '', active: true });
        this._dictionary.add('363', { id: 363, militaryCityPrefixTypeId: 2, jurisdictionId: 67, value: '09730', city: '', active: true });
        this._dictionary.add('364', { id: 364, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09731', city: '', active: true });
        this._dictionary.add('365', { id: 365, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09732', city: '', active: true });
        this._dictionary.add('366', { id: 366, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09734', city: '', active: true });
        this._dictionary.add('367', { id: 367, militaryCityPrefixTypeId: 2, jurisdictionId: 67, value: '09736', city: '', active: true });
        this._dictionary.add('368', { id: 368, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09737', city: '', active: true });
        this._dictionary.add('369', { id: 369, militaryCityPrefixTypeId: 2, jurisdictionId: 67, value: '09739', city: '', active: true });
        this._dictionary.add('370', { id: 370, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09742', city: '', active: true });
        this._dictionary.add('371', { id: 371, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09743', city: '', active: true });
        this._dictionary.add('372', { id: 372, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09744', city: '', active: true });
        this._dictionary.add('373', { id: 373, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09751', city: '', active: true });
        this._dictionary.add('374', { id: 374, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09752', city: '', active: true });
        this._dictionary.add('375', { id: 375, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09754', city: '', active: true });
        this._dictionary.add('376', { id: 376, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09755', city: '', active: true });
        this._dictionary.add('377', { id: 377, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09757', city: '', active: true });
        this._dictionary.add('378', { id: 378, militaryCityPrefixTypeId: 2, jurisdictionId: 67, value: '09762', city: '', active: true });
        this._dictionary.add('379', { id: 379, militaryCityPrefixTypeId: 2, jurisdictionId: 67, value: '09769', city: '', active: true });
        this._dictionary.add('380', { id: 380, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09777', city: '', active: true });
        this._dictionary.add('381', { id: 381, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09786', city: '', active: true });
        this._dictionary.add('382', { id: 382, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09789', city: '', active: true });
        this._dictionary.add('383', { id: 383, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09790', city: '', active: true });
        this._dictionary.add('384', { id: 384, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09794', city: '', active: true });
        this._dictionary.add('385', { id: 385, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09801', city: '', active: true });
        this._dictionary.add('386', { id: 386, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09803', city: '', active: true });
        this._dictionary.add('387', { id: 387, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09806', city: '', active: true });
        this._dictionary.add('388', { id: 388, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09809', city: '', active: true });
        this._dictionary.add('389', { id: 389, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09812', city: '', active: true });
        this._dictionary.add('390', { id: 390, militaryCityPrefixTypeId: 2, jurisdictionId: 67, value: '09817', city: '', active: true });
        this._dictionary.add('391', { id: 391, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09821', city: '', active: true });
        this._dictionary.add('392', { id: 392, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09822', city: '', active: true });
        this._dictionary.add('393', { id: 393, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09823', city: '', active: true });
        this._dictionary.add('394', { id: 394, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09824', city: '', active: true });
        this._dictionary.add('395', { id: 395, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09825', city: '', active: true });
        this._dictionary.add('396', { id: 396, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09827', city: '', active: true });
        this._dictionary.add('397', { id: 397, militaryCityPrefixTypeId: 2, jurisdictionId: 67, value: '09828', city: '', active: true });
        this._dictionary.add('398', { id: 398, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09830', city: '', active: true });
        this._dictionary.add('399', { id: 399, militaryCityPrefixTypeId: 2, jurisdictionId: 67, value: '09831', city: '', active: true });
        this._dictionary.add('400', { id: 400, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09833', city: '', active: true });
        this._dictionary.add('401', { id: 401, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09834', city: '', active: true });
        this._dictionary.add('402', { id: 402, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09836', city: '', active: true });
        this._dictionary.add('403', { id: 403, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09838', city: '', active: true });
        this._dictionary.add('404', { id: 404, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09839', city: '', active: true });
        this._dictionary.add('405', { id: 405, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09841', city: '', active: true });
        this._dictionary.add('406', { id: 406, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09842', city: '', active: true });
        this._dictionary.add('407', { id: 407, militaryCityPrefixTypeId: 2, jurisdictionId: 67, value: '09843', city: '', active: true });
        this._dictionary.add('408', { id: 408, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09846', city: '', active: true });
        this._dictionary.add('409', { id: 409, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09852', city: '', active: true });
        this._dictionary.add('410', { id: 410, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09858', city: '', active: true });
        this._dictionary.add('411', { id: 411, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09860', city: '', active: true });
        this._dictionary.add('412', { id: 412, militaryCityPrefixTypeId: 3, jurisdictionId: 67, value: '09865', city: '', active: true });
        this._dictionary.add('413', { id: 413, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09870', city: '', active: true });
        this._dictionary.add('414', { id: 414, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09880', city: '', active: true });
        this._dictionary.add('415', { id: 415, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09881', city: '', active: true });
        this._dictionary.add('416', { id: 416, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09889', city: '', active: true });
        this._dictionary.add('417', { id: 417, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09890', city: '', active: true });
        this._dictionary.add('418', { id: 418, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09892', city: '', active: true });
        this._dictionary.add('419', { id: 419, militaryCityPrefixTypeId: 1, jurisdictionId: 67, value: '09898', city: '', active: true });
        this._dictionary.add('420', { id: 420, militaryCityPrefixTypeId: 1, jurisdictionId: 66, value: '34001', city: '', active: true });
        this._dictionary.add('421', { id: 421, militaryCityPrefixTypeId: 1, jurisdictionId: 66, value: '34002', city: '', active: true });
        this._dictionary.add('422', { id: 422, militaryCityPrefixTypeId: 1, jurisdictionId: 66, value: '34003', city: '', active: true });
        this._dictionary.add('423', { id: 423, militaryCityPrefixTypeId: 1, jurisdictionId: 66, value: '34004', city: '', active: true });
        this._dictionary.add('424', { id: 424, militaryCityPrefixTypeId: 1, jurisdictionId: 66, value: '34005', city: '', active: true });
        this._dictionary.add('425', { id: 425, militaryCityPrefixTypeId: 1, jurisdictionId: 66, value: '34007', city: '', active: true });
        this._dictionary.add('426', { id: 426, militaryCityPrefixTypeId: 1, jurisdictionId: 66, value: '34020', city: '', active: true });
        this._dictionary.add('427', { id: 427, militaryCityPrefixTypeId: 1, jurisdictionId: 66, value: '34021', city: '', active: true });
        this._dictionary.add('428', { id: 428, militaryCityPrefixTypeId: 1, jurisdictionId: 66, value: '34022', city: '', active: true });
        this._dictionary.add('429', { id: 429, militaryCityPrefixTypeId: 1, jurisdictionId: 66, value: '34023', city: '', active: true });
        this._dictionary.add('430', { id: 430, militaryCityPrefixTypeId: 1, jurisdictionId: 66, value: '34024', city: '', active: true });
        this._dictionary.add('431', { id: 431, militaryCityPrefixTypeId: 1, jurisdictionId: 66, value: '34030', city: '', active: true });
        this._dictionary.add('432', { id: 432, militaryCityPrefixTypeId: 2, jurisdictionId: 66, value: '34031', city: '', active: true });
        this._dictionary.add('433', { id: 433, militaryCityPrefixTypeId: 1, jurisdictionId: 66, value: '34032', city: '', active: true });
        this._dictionary.add('434', { id: 434, militaryCityPrefixTypeId: 1, jurisdictionId: 66, value: '34033', city: '', active: true });
        this._dictionary.add('435', { id: 435, militaryCityPrefixTypeId: 2, jurisdictionId: 66, value: '34034', city: '', active: true });
        this._dictionary.add('436', { id: 436, militaryCityPrefixTypeId: 1, jurisdictionId: 66, value: '34035', city: '', active: true });
        this._dictionary.add('437', { id: 437, militaryCityPrefixTypeId: 1, jurisdictionId: 66, value: '34037', city: '', active: true });
        this._dictionary.add('438', { id: 438, militaryCityPrefixTypeId: 1, jurisdictionId: 66, value: '34038', city: '', active: true });
        this._dictionary.add('439', { id: 439, militaryCityPrefixTypeId: 1, jurisdictionId: 66, value: '34039', city: '', active: true });
        this._dictionary.add('440', { id: 440, militaryCityPrefixTypeId: 1, jurisdictionId: 66, value: '34042', city: '', active: true });
        this._dictionary.add('441', { id: 441, militaryCityPrefixTypeId: 3, jurisdictionId: 66, value: '34051', city: '', active: true });
        this._dictionary.add('442', { id: 442, militaryCityPrefixTypeId: 3, jurisdictionId: 66, value: '34053', city: '', active: true });
        this._dictionary.add('443', { id: 443, militaryCityPrefixTypeId: 3, jurisdictionId: 66, value: '34058', city: '', active: true });
        this._dictionary.add('444', { id: 444, militaryCityPrefixTypeId: 3, jurisdictionId: 66, value: '34061', city: '', active: true });
        this._dictionary.add('445', { id: 445, militaryCityPrefixTypeId: 3, jurisdictionId: 66, value: '34078', city: '', active: true });
        this._dictionary.add('446', { id: 446, militaryCityPrefixTypeId: 3, jurisdictionId: 66, value: '34080', city: '', active: true });
        this._dictionary.add('447', { id: 447, militaryCityPrefixTypeId: 3, jurisdictionId: 66, value: '34083', city: '', active: true });
        this._dictionary.add('448', { id: 448, militaryCityPrefixTypeId: 3, jurisdictionId: 66, value: '34085', city: '', active: true });
        this._dictionary.add('449', { id: 449, militaryCityPrefixTypeId: 3, jurisdictionId: 66, value: '34086', city: '', active: true });
        this._dictionary.add('450', { id: 450, militaryCityPrefixTypeId: 3, jurisdictionId: 66, value: '34087', city: '', active: true });
        this._dictionary.add('451', { id: 451, militaryCityPrefixTypeId: 3, jurisdictionId: 66, value: '34088', city: '', active: true });
        this._dictionary.add('452', { id: 452, militaryCityPrefixTypeId: 3, jurisdictionId: 66, value: '34090', city: '', active: true });
        this._dictionary.add('453', { id: 453, militaryCityPrefixTypeId: 3, jurisdictionId: 66, value: '34091', city: '', active: true });
        this._dictionary.add('454', { id: 454, militaryCityPrefixTypeId: 3, jurisdictionId: 66, value: '34092', city: '', active: true });
        this._dictionary.add('455', { id: 455, militaryCityPrefixTypeId: 3, jurisdictionId: 66, value: '34093', city: '', active: true });
        this._dictionary.add('456', { id: 456, militaryCityPrefixTypeId: 3, jurisdictionId: 66, value: '34095', city: '', active: true });
        this._dictionary.add('457', { id: 457, militaryCityPrefixTypeId: 3, jurisdictionId: 66, value: '34097', city: '', active: true });
        this._dictionary.add('458', { id: 458, militaryCityPrefixTypeId: 3, jurisdictionId: 66, value: '34099', city: '', active: true });
        this._dictionary.add('459', { id: 459, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96202', city: '', active: true });
        this._dictionary.add('460', { id: 460, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96204', city: '', active: true });
        this._dictionary.add('461', { id: 461, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96205', city: '', active: true });
        this._dictionary.add('462', { id: 462, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96206', city: '', active: true });
        this._dictionary.add('463', { id: 463, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96207', city: '', active: true });
        this._dictionary.add('464', { id: 464, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96208', city: '', active: true });
        this._dictionary.add('465', { id: 465, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96212', city: '', active: true });
        this._dictionary.add('466', { id: 466, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96213', city: '', active: true });
        this._dictionary.add('467', { id: 467, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96214', city: '', active: true });
        this._dictionary.add('468', { id: 468, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96218', city: '', active: true });
        this._dictionary.add('469', { id: 469, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96224', city: '', active: true });
        this._dictionary.add('470', { id: 470, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96230', city: '', active: true });
        this._dictionary.add('471', { id: 471, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96239', city: '', active: true });
        this._dictionary.add('472', { id: 472, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96248', city: '', active: true });
        this._dictionary.add('473', { id: 473, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96251', city: '', active: true });
        this._dictionary.add('474', { id: 474, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96257', city: '', active: true });
        this._dictionary.add('475', { id: 475, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96258', city: '', active: true });
        this._dictionary.add('476', { id: 476, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96259', city: '', active: true });
        this._dictionary.add('477', { id: 477, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96260', city: '', active: true });
        this._dictionary.add('478', { id: 478, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96264', city: '', active: true });
        this._dictionary.add('479', { id: 479, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96266', city: '', active: true });
        this._dictionary.add('480', { id: 480, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96271', city: '', active: true });
        this._dictionary.add('481', { id: 481, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96274', city: '', active: true });
        this._dictionary.add('482', { id: 482, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96275', city: '', active: true });
        this._dictionary.add('483', { id: 483, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96278', city: '', active: true });
        this._dictionary.add('484', { id: 484, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96286', city: '', active: true });
        this._dictionary.add('485', { id: 485, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96293', city: '', active: true });
        this._dictionary.add('486', { id: 486, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96301', city: '', active: true });
        this._dictionary.add('487', { id: 487, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96303', city: '', active: true });
        this._dictionary.add('488', { id: 488, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96305', city: '', active: true });
        this._dictionary.add('489', { id: 489, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96306', city: '', active: true });
        this._dictionary.add('490', { id: 490, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96311', city: '', active: true });
        this._dictionary.add('491', { id: 491, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96313', city: '', active: true });
        this._dictionary.add('492', { id: 492, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96319', city: '', active: true });
        this._dictionary.add('493', { id: 493, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96321', city: '', active: true });
        this._dictionary.add('494', { id: 494, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96322', city: '', active: true });
        this._dictionary.add('495', { id: 495, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96324', city: '', active: true });
        this._dictionary.add('496', { id: 496, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96326', city: '', active: true });
        this._dictionary.add('497', { id: 497, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96328', city: '', active: true });
        this._dictionary.add('498', { id: 498, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96331', city: '', active: true });
        this._dictionary.add('499', { id: 499, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96334', city: '', active: true });
        this._dictionary.add('500', { id: 500, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96335', city: '', active: true });
        this._dictionary.add('501', { id: 501, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96336', city: '', active: true });
        this._dictionary.add('502', { id: 502, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96337', city: '', active: true });
        this._dictionary.add('503', { id: 503, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96338', city: '', active: true });
        this._dictionary.add('504', { id: 504, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96343', city: '', active: true });
        this._dictionary.add('505', { id: 505, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96347', city: '', active: true });
        this._dictionary.add('506', { id: 506, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96348', city: '', active: true });
        this._dictionary.add('507', { id: 507, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96349', city: '', active: true });
        this._dictionary.add('508', { id: 508, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96350', city: '', active: true });
        this._dictionary.add('509', { id: 509, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96351', city: '', active: true });
        this._dictionary.add('510', { id: 510, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96358', city: '', active: true });
        this._dictionary.add('511', { id: 511, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96362', city: '', active: true });
        this._dictionary.add('512', { id: 512, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96364', city: '', active: true });
        this._dictionary.add('513', { id: 513, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96366', city: '', active: true });
        this._dictionary.add('514', { id: 514, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96367', city: '', active: true });
        this._dictionary.add('515', { id: 515, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96368', city: '', active: true });
        this._dictionary.add('516', { id: 516, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96369', city: '', active: true });
        this._dictionary.add('517', { id: 517, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96370', city: '', active: true });
        this._dictionary.add('518', { id: 518, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96372', city: '', active: true });
        this._dictionary.add('519', { id: 519, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96373', city: '', active: true });
        this._dictionary.add('520', { id: 520, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96374', city: '', active: true });
        this._dictionary.add('521', { id: 521, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96375', city: '', active: true });
        this._dictionary.add('522', { id: 522, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96376', city: '', active: true });
        this._dictionary.add('523', { id: 523, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96377', city: '', active: true });
        this._dictionary.add('524', { id: 524, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96379', city: '', active: true });
        this._dictionary.add('525', { id: 525, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96384', city: '', active: true });
        this._dictionary.add('526', { id: 526, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96386', city: '', active: true });
        this._dictionary.add('527', { id: 527, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96408', city: '', active: true });
        this._dictionary.add('528', { id: 528, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96427', city: '', active: true });
        this._dictionary.add('529', { id: 529, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96432', city: '', active: true });
        this._dictionary.add('530', { id: 530, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96450', city: '', active: true });
        this._dictionary.add('531', { id: 531, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96455', city: '', active: true });
        this._dictionary.add('532', { id: 532, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96460', city: '', active: true });
        this._dictionary.add('533', { id: 533, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96461', city: '', active: true });
        this._dictionary.add('534', { id: 534, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96464', city: '', active: true });
        this._dictionary.add('535', { id: 535, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96505', city: '', active: true });
        this._dictionary.add('536', { id: 536, militaryCityPrefixTypeId: 2, jurisdictionId: 68, value: '96507', city: '', active: true });
        this._dictionary.add('537', { id: 537, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96508', city: '', active: true });
        this._dictionary.add('538', { id: 538, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96510', city: '', active: true });
        this._dictionary.add('539', { id: 539, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96512', city: '', active: true });
        this._dictionary.add('540', { id: 540, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96515', city: '', active: true });
        this._dictionary.add('541', { id: 541, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96519', city: '', active: true });
        this._dictionary.add('542', { id: 542, militaryCityPrefixTypeId: 2, jurisdictionId: 68, value: '96520', city: '', active: true });
        this._dictionary.add('543', { id: 543, militaryCityPrefixTypeId: 2, jurisdictionId: 68, value: '96521', city: '', active: true });
        this._dictionary.add('544', { id: 544, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96524', city: '', active: true });
        this._dictionary.add('545', { id: 545, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96528', city: '', active: true });
        this._dictionary.add('546', { id: 546, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96533', city: '', active: true });
        this._dictionary.add('547', { id: 547, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96534', city: '', active: true });
        this._dictionary.add('548', { id: 548, militaryCityPrefixTypeId: 2, jurisdictionId: 68, value: '96535', city: '', active: true });
        this._dictionary.add('549', { id: 549, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96538', city: '', active: true });
        this._dictionary.add('550', { id: 550, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96539', city: '', active: true });
        this._dictionary.add('551', { id: 551, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96540', city: '', active: true });
        this._dictionary.add('552', { id: 552, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96542', city: '', active: true });
        this._dictionary.add('553', { id: 553, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96543', city: '', active: true });
        this._dictionary.add('554', { id: 554, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96546', city: '', active: true });
        this._dictionary.add('555', { id: 555, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96548', city: '', active: true });
        this._dictionary.add('556', { id: 556, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96549', city: '', active: true });
        this._dictionary.add('557', { id: 557, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96551', city: '', active: true });
        this._dictionary.add('558', { id: 558, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96552', city: '', active: true });
        this._dictionary.add('559', { id: 559, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96553', city: '', active: true });
        this._dictionary.add('560', { id: 560, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96554', city: '', active: true });
        this._dictionary.add('561', { id: 561, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96555', city: '', active: true });
        this._dictionary.add('562', { id: 562, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96557', city: '', active: true });
        this._dictionary.add('563', { id: 563, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96558', city: '', active: true });
        this._dictionary.add('564', { id: 564, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96595', city: '', active: true });
        this._dictionary.add('565', { id: 565, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96601', city: '', active: true });
        this._dictionary.add('566', { id: 566, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96602', city: '', active: true });
        this._dictionary.add('567', { id: 567, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96603', city: '', active: true });
        this._dictionary.add('568', { id: 568, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96604', city: '', active: true });
        this._dictionary.add('569', { id: 569, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96606', city: '', active: true });
        this._dictionary.add('570', { id: 570, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96607', city: '', active: true });
        this._dictionary.add('571', { id: 571, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96608', city: '', active: true });
        this._dictionary.add('572', { id: 572, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96609', city: '', active: true });
        this._dictionary.add('573', { id: 573, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96610', city: '', active: true });
        this._dictionary.add('574', { id: 574, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96612', city: '', active: true });
        this._dictionary.add('575', { id: 575, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96614', city: '', active: true });
        this._dictionary.add('576', { id: 576, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96615', city: '', active: true });
        this._dictionary.add('577', { id: 577, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96616', city: '', active: true });
        this._dictionary.add('578', { id: 578, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96617', city: '', active: true });
        this._dictionary.add('579', { id: 579, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96618', city: '', active: true });
        this._dictionary.add('580', { id: 580, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96620', city: '', active: true });
        this._dictionary.add('581', { id: 581, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96621', city: '', active: true });
        this._dictionary.add('582', { id: 582, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96622', city: '', active: true });
        this._dictionary.add('583', { id: 583, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96623', city: '', active: true });
        this._dictionary.add('584', { id: 584, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96624', city: '', active: true });
        this._dictionary.add('585', { id: 585, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96626', city: '', active: true });
        this._dictionary.add('586', { id: 586, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96627', city: '', active: true });
        this._dictionary.add('587', { id: 587, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96628', city: '', active: true });
        this._dictionary.add('588', { id: 588, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96629', city: '', active: true });
        this._dictionary.add('589', { id: 589, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96630', city: '', active: true });
        this._dictionary.add('590', { id: 590, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96631', city: '', active: true });
        this._dictionary.add('591', { id: 591, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96632', city: '', active: true });
        this._dictionary.add('592', { id: 592, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96633', city: '', active: true });
        this._dictionary.add('593', { id: 593, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96634', city: '', active: true });
        this._dictionary.add('594', { id: 594, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96635', city: '', active: true });
        this._dictionary.add('595', { id: 595, militaryCityPrefixTypeId: 1, jurisdictionId: 68, value: '96636', city: '', active: true });
        this._dictionary.add('596', { id: 596, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96637', city: '', active: true });
        this._dictionary.add('597', { id: 597, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96639', city: '', active: true });
        this._dictionary.add('598', { id: 598, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96641', city: '', active: true });
        this._dictionary.add('599', { id: 599, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96642', city: '', active: true });
        this._dictionary.add('600', { id: 600, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96643', city: '', active: true });
        this._dictionary.add('601', { id: 601, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96644', city: '', active: true });
        this._dictionary.add('602', { id: 602, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96646', city: '', active: true });
        this._dictionary.add('603', { id: 603, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96647', city: '', active: true });
        this._dictionary.add('604', { id: 604, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96648', city: '', active: true });
        this._dictionary.add('605', { id: 605, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96649', city: '', active: true });
        this._dictionary.add('606', { id: 606, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96651', city: '', active: true });
        this._dictionary.add('607', { id: 607, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96654', city: '', active: true });
        this._dictionary.add('608', { id: 608, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96656', city: '', active: true });
        this._dictionary.add('609', { id: 609, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96657', city: '', active: true });
        this._dictionary.add('610', { id: 610, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96660', city: '', active: true });
        this._dictionary.add('611', { id: 611, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96661', city: '', active: true });
        this._dictionary.add('612', { id: 612, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96662', city: '', active: true });
        this._dictionary.add('613', { id: 613, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96663', city: '', active: true });
        this._dictionary.add('614', { id: 614, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96664', city: '', active: true });
        this._dictionary.add('615', { id: 615, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96665', city: '', active: true });
        this._dictionary.add('616', { id: 616, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96666', city: '', active: true });
        this._dictionary.add('617', { id: 617, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96667', city: '', active: true });
        this._dictionary.add('618', { id: 618, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96669', city: '', active: true });
        this._dictionary.add('619', { id: 619, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96670', city: '', active: true });
        this._dictionary.add('620', { id: 620, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96671', city: '', active: true });
        this._dictionary.add('621', { id: 621, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96672', city: '', active: true });
        this._dictionary.add('622', { id: 622, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96673', city: '', active: true });
        this._dictionary.add('623', { id: 623, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96674', city: '', active: true });
        this._dictionary.add('624', { id: 624, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96675', city: '', active: true });
        this._dictionary.add('625', { id: 625, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96677', city: '', active: true });
        this._dictionary.add('626', { id: 626, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96678', city: '', active: true });
        this._dictionary.add('627', { id: 627, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96679', city: '', active: true });
        this._dictionary.add('628', { id: 628, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96680', city: '', active: true });
        this._dictionary.add('629', { id: 629, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96682', city: '', active: true });
        this._dictionary.add('630', { id: 630, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96683', city: '', active: true });
        this._dictionary.add('631', { id: 631, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96685', city: '', active: true });
        this._dictionary.add('632', { id: 632, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96688', city: '', active: true });
        this._dictionary.add('633', { id: 633, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96697', city: '', active: true });
        this._dictionary.add('634', { id: 634, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96698', city: '', active: true });
        this._dictionary.add('635', { id: 635, militaryCityPrefixTypeId: 3, jurisdictionId: 48, value: '98772', city: '', active: true });
        this._dictionary.add('636', { id: 636, militaryCityPrefixTypeId: 3, jurisdictionId: 48, value: '98775', city: '', active: true });
        this._dictionary.add('637', { id: 637, militaryCityPrefixTypeId: 1, jurisdictionId: 66, value: '85309', city: '', active: true });
        this._dictionary.add('638', { id: 638, militaryCityPrefixTypeId: 1, jurisdictionId: 66, value: '85708', city: '', active: true });
        this._dictionary.add('639', { id: 639, militaryCityPrefixTypeId: 3, jurisdictionId: 68, value: '96380', city: '', active: true });
    }

    public ToString(): string {
        return this.value == null ? null : this.value.toString();
    }

    public FromId(id: number): IMilitaryZipCode {
        return this._dictionary[id];
    }

    public FromValue(value: string): IMilitaryZipCode {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IMilitaryZipCode[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IMilitaryZipCode[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IMilitaryZipCode[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
